/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 50);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(58);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(73)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
	This component provides a technique for setting timeouts in your render function.
	The timeouts get cleared as soon as you re-render (or unmount), so you don't
	have to keep track of them. 

	The idea is that a timeout should be a function of state (ie. state A automatically
	advances to state B after 5s), and as soon as you change state (ie. state A moves
	to state C on click of button) the timeout should be cleared.

	The reset_prevention_key prop can be used when certain state transitions should 
	not cause the timeout to reset (or if your component might be rendered multiple
	times in the same state).

	Note - we could change this implementation so that the on_timeout callback
	is always called from within a React event handler.
	We'd create an invisible element, with a css transition, and attach the
	callback to the element's onTransitionEnd.
	
	I'm not sure if that has too much advantage, though.
*/var Timer=function(_Component){_inherits(Timer,_Component);function Timer(props){_classCallCheck(this,Timer);var _this=_possibleConstructorReturn(this,(Timer.__proto__||Object.getPrototypeOf(Timer)).call(this,props));_this.timeout_id=null;return _this;}_createClass(Timer,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){return nextProps.reset_prevention_key===null||nextProps.reset_prevention_key!==this.props.reset_prevention_key;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.clear_timeout();}},{key:'clear_timeout',value:function clear_timeout(){if(this.timeout_id!==null){clearTimeout(this.timeout_id);}this.timeout_id=null;}},{key:'render',value:function render(){var _props=this.props,on_timeout=_props.on_timeout,delay=_props.delay;this.clear_timeout();this.timeout_id=setTimeout(on_timeout,delay);return null;}}]);return Timer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Timer);Timer.propTypes={on_timeout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,delay:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,/*
		By default, Timer will reset its timeout on every render.
		If you want to prevent this, you can pass in a value to this prop.
		If this prop is not null and compares strictly equal on multiple
		consecutive renders, then the timeout will not be reset.
		(Note that you can other falsy values, like 0 or false, to prevent reset)
	*/reset_prevention_key:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};Timer.defaultProps={// Passing null or no value at all (undefined) should be treated the same
reset_prevention_key:null};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(31);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(32);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(17);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SOUND_LONG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SOUND_SHORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return all_sounds; });
/* harmony export (immutable) */ __webpack_exports__["e"] = playSound;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return play; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_Koobot_Processed_01B_mp3__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_sounds_Koobot_Processed_01B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_sounds_Koobot_Processed_01B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sounds_Koobot_Processed_02B_mp3__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_sounds_Koobot_Processed_02B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_sounds_Koobot_Processed_02B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_sounds_Koobot_Processed_03B_mp3__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_sounds_Koobot_Processed_03B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_sounds_Koobot_Processed_03B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_sounds_Koobot_Processed_04B_mp3__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_sounds_Koobot_Processed_04B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_sounds_Koobot_Processed_04B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_sounds_Koobot_Processed_05B_mp3__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_sounds_Koobot_Processed_05B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_sounds_Koobot_Processed_05B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_sounds_Koobot_Processed_06B_mp3__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_sounds_Koobot_Processed_06B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_sounds_Koobot_Processed_06B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_sounds_Koobot_Processed_07B_mp3__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_sounds_Koobot_Processed_07B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_sounds_Koobot_Processed_07B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sounds_Koobot_Processed_08B_mp3__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sounds_Koobot_Processed_08B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sounds_Koobot_Processed_08B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_sounds_Koobot_Processed_09B_mp3__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_sounds_Koobot_Processed_09B_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_sounds_Koobot_Processed_09B_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_sounds_Koobot_Processed_01A_mp3__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_sounds_Koobot_Processed_01A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_sounds_Koobot_Processed_01A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sounds_Koobot_Processed_02A_mp3__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sounds_Koobot_Processed_02A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_sounds_Koobot_Processed_02A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_sounds_Koobot_Processed_03A_mp3__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_sounds_Koobot_Processed_03A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_sounds_Koobot_Processed_03A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sounds_Koobot_Processed_04A_mp3__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sounds_Koobot_Processed_04A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_sounds_Koobot_Processed_04A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sounds_Koobot_Processed_05A_mp3__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_sounds_Koobot_Processed_05A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_sounds_Koobot_Processed_05A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sounds_Koobot_Processed_06A_mp3__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_sounds_Koobot_Processed_06A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_sounds_Koobot_Processed_06A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sounds_Koobot_Processed_07A_mp3__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_sounds_Koobot_Processed_07A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_sounds_Koobot_Processed_07A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sounds_Koobot_Processed_08A_mp3__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_sounds_Koobot_Processed_08A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_sounds_Koobot_Processed_08A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sounds_Koobot_Processed_09A_mp3__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_sounds_Koobot_Processed_09A_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_sounds_Koobot_Processed_09A_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sounds_E_01_WIN_mp3__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_sounds_E_01_WIN_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_sounds_E_01_WIN_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sounds_E_01_FAIL_mp3__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sounds_E_01_FAIL_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_sounds_E_01_FAIL_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_success_DM_Positive_Clip_1_mp3__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_success_DM_Positive_Clip_1_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_success_DM_Positive_Clip_1_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_success_DM_Positive_Clip_2_mp3__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_success_DM_Positive_Clip_2_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_success_DM_Positive_Clip_2_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_success_DM_Positive_Clip_3_mp3__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_success_DM_Positive_Clip_3_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_success_DM_Positive_Clip_3_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_success_DM_Positive_Clip_4_mp3__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_success_DM_Positive_Clip_4_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_success_DM_Positive_Clip_4_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_success_DM_Positive_Clip_5_mp3__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_success_DM_Positive_Clip_5_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_success_DM_Positive_Clip_5_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_success_DM_Positive_Clip_6_mp3__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_success_DM_Positive_Clip_6_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_success_DM_Positive_Clip_6_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_success_DM_Positive_Clip_7_mp3__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_success_DM_Positive_Clip_7_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_success_DM_Positive_Clip_7_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_success_DM_Positive_Clip_8_mp3__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_success_DM_Positive_Clip_8_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_success_DM_Positive_Clip_8_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_success_DM_Negative_Clip_1_mp3__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_success_DM_Negative_Clip_1_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_success_DM_Negative_Clip_1_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_success_DM_Negative_Clip_2_mp3__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_success_DM_Negative_Clip_2_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_success_DM_Negative_Clip_2_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_success_DM_Negative_Clip_3_mp3__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_success_DM_Negative_Clip_3_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_success_DM_Negative_Clip_3_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_success_DM_Negative_Clip_4_mp3__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_success_DM_Negative_Clip_4_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_success_DM_Negative_Clip_4_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_success_DM_Negative_Clip_5_mp3__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_success_DM_Negative_Clip_5_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_success_DM_Negative_Clip_5_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_success_DM_Negative_Clip_6_mp3__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_success_DM_Negative_Clip_6_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_success_DM_Negative_Clip_6_mp3__);
// Note - static imports like this are kind of a pain, but they enable 
// cache-busting file name hashes, among other benefits.
// For a comparison of this approach vs the public folder, see:
// https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-the-public-folder
// createjs is a globally included script
var createjs=window.createjs;/*
    Note - I'm pretty sure you can't possibly use HTMLAudioPlugin
    with Preloadjs. Doesn't seem to be well documented.
    So if we need to use HTMLAudioPlugin (ie. for IE support)
    we'll have to drop Preloadjs and just use createjs.Sound.registerSound
*/createjs.Sound.registerPlugins([createjs.WebAudioPlugin,createjs.HTMLAudioPlugin]);// sound 'types';
var SOUND_LONG='long';var SOUND_SHORT='short';function idForSound(sound_type,robot_index){return sound_type+'_'+robot_index;}var all_sounds=[{id:'long_1',src:__WEBPACK_IMPORTED_MODULE_9__assets_sounds_Koobot_Processed_01A_mp3___default.a},{id:'long_2',src:__WEBPACK_IMPORTED_MODULE_10__assets_sounds_Koobot_Processed_02A_mp3___default.a},{id:'long_3',src:__WEBPACK_IMPORTED_MODULE_11__assets_sounds_Koobot_Processed_03A_mp3___default.a},{id:'long_4',src:__WEBPACK_IMPORTED_MODULE_12__assets_sounds_Koobot_Processed_04A_mp3___default.a},{id:'long_5',src:__WEBPACK_IMPORTED_MODULE_13__assets_sounds_Koobot_Processed_05A_mp3___default.a},{id:'long_6',src:__WEBPACK_IMPORTED_MODULE_14__assets_sounds_Koobot_Processed_06A_mp3___default.a},{id:'long_7',src:__WEBPACK_IMPORTED_MODULE_15__assets_sounds_Koobot_Processed_07A_mp3___default.a},{id:'long_8',src:__WEBPACK_IMPORTED_MODULE_16__assets_sounds_Koobot_Processed_08A_mp3___default.a},{id:'long_9',src:__WEBPACK_IMPORTED_MODULE_17__assets_sounds_Koobot_Processed_09A_mp3___default.a},{id:'short_1',src:__WEBPACK_IMPORTED_MODULE_0__assets_sounds_Koobot_Processed_01B_mp3___default.a},{id:'short_2',src:__WEBPACK_IMPORTED_MODULE_1__assets_sounds_Koobot_Processed_02B_mp3___default.a},{id:'short_3',src:__WEBPACK_IMPORTED_MODULE_2__assets_sounds_Koobot_Processed_03B_mp3___default.a},{id:'short_4',src:__WEBPACK_IMPORTED_MODULE_3__assets_sounds_Koobot_Processed_04B_mp3___default.a},{id:'short_5',src:__WEBPACK_IMPORTED_MODULE_4__assets_sounds_Koobot_Processed_05B_mp3___default.a},{id:'short_6',src:__WEBPACK_IMPORTED_MODULE_5__assets_sounds_Koobot_Processed_06B_mp3___default.a},{id:'short_7',src:__WEBPACK_IMPORTED_MODULE_6__assets_sounds_Koobot_Processed_07B_mp3___default.a},{id:'short_8',src:__WEBPACK_IMPORTED_MODULE_7__assets_sounds_Koobot_Processed_08B_mp3___default.a},{id:'short_9',src:__WEBPACK_IMPORTED_MODULE_8__assets_sounds_Koobot_Processed_09B_mp3___default.a},{id:'success',src:__WEBPACK_IMPORTED_MODULE_18__assets_sounds_E_01_WIN_mp3___default.a},{id:'fail',src:__WEBPACK_IMPORTED_MODULE_19__assets_sounds_E_01_FAIL_mp3___default.a},{id:'success_1',src:__WEBPACK_IMPORTED_MODULE_20__assets_success_DM_Positive_Clip_1_mp3___default.a},{id:'success_2',src:__WEBPACK_IMPORTED_MODULE_21__assets_success_DM_Positive_Clip_2_mp3___default.a},{id:'success_3',src:__WEBPACK_IMPORTED_MODULE_22__assets_success_DM_Positive_Clip_3_mp3___default.a},{id:'success_4',src:__WEBPACK_IMPORTED_MODULE_23__assets_success_DM_Positive_Clip_4_mp3___default.a},{id:'success_5',src:__WEBPACK_IMPORTED_MODULE_24__assets_success_DM_Positive_Clip_5_mp3___default.a},{id:'success_6',src:__WEBPACK_IMPORTED_MODULE_25__assets_success_DM_Positive_Clip_6_mp3___default.a},{id:'success_7',src:__WEBPACK_IMPORTED_MODULE_26__assets_success_DM_Positive_Clip_7_mp3___default.a},{id:'success_8',src:__WEBPACK_IMPORTED_MODULE_27__assets_success_DM_Positive_Clip_8_mp3___default.a},{id:'fail_1',src:__WEBPACK_IMPORTED_MODULE_28__assets_success_DM_Negative_Clip_1_mp3___default.a},{id:'fail_2',src:__WEBPACK_IMPORTED_MODULE_29__assets_success_DM_Negative_Clip_2_mp3___default.a},{id:'fail_3',src:__WEBPACK_IMPORTED_MODULE_30__assets_success_DM_Negative_Clip_3_mp3___default.a},{id:'fail_4',src:__WEBPACK_IMPORTED_MODULE_31__assets_success_DM_Negative_Clip_4_mp3___default.a},{id:'fail_5',src:__WEBPACK_IMPORTED_MODULE_32__assets_success_DM_Negative_Clip_5_mp3___default.a},{id:'fail_6',src:__WEBPACK_IMPORTED_MODULE_33__assets_success_DM_Negative_Clip_6_mp3___default.a}];function playSound(sound_type,robot_index){var soundjs_options=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return createjs.Sound.play(idForSound(sound_type,robot_index),soundjs_options);}var play=createjs.Sound.play.bind(createjs.Sound);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var core = __webpack_require__(7);
var hide = __webpack_require__(22);
var redefine = __webpack_require__(145);
var ctx = __webpack_require__(41);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(139);
var createDesc = __webpack_require__(144);
module.exports = __webpack_require__(23) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(41);
var IObject = __webpack_require__(148);
var toObject = __webpack_require__(149);
var toLength = __webpack_require__(151);
var asc = __webpack_require__(153);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KeyboardSelectionListener__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
	This component is a basic wrapper component to make buttons, etc. keyboard focusable and selectable.
*/var Focusable=function(_Component){_inherits(Focusable,_Component);function Focusable(){_classCallCheck(this,Focusable);return _possibleConstructorReturn(this,(Focusable.__proto__||Object.getPrototypeOf(Focusable)).apply(this,arguments));}_createClass(Focusable,[{key:'render',value:function render(){var _props=this.props,has_focus=_props.has_focus,focus_ref=_props.focus_ref,on_select=_props.on_select,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{outline:has_focus?'6px solid orange':'none'},ref:focus_ref},has_focus&&on_select?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__KeyboardSelectionListener__["a" /* default */],{on_select:on_select}):null,children);}}]);return Focusable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Focusable);Focusable.propTypes={has_focus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,focus_ref:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,on_select:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Focusable.defaultProps={on_select:null};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
	This component should be rendered by any component which has "focus" and
	want to respond to being "selected".
*/var KeyboardSelectionListener=function(_Component){_inherits(KeyboardSelectionListener,_Component);function KeyboardSelectionListener(){_classCallCheck(this,KeyboardSelectionListener);return _possibleConstructorReturn(this,(KeyboardSelectionListener.__proto__||Object.getPrototypeOf(KeyboardSelectionListener)).apply(this,arguments));}_createClass(KeyboardSelectionListener,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.listener=function(event){if(event.key==='Enter'||event.key===' '){if(event.ctrlKey||event.metaKey||event.shiftKey){return;}_this2.props.on_select(event);}};window.addEventListener('keypress',this.listener);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('keypress',this.listener);}},{key:'render',value:function render(){return null;}}]);return KeyboardSelectionListener;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardSelectionListener);KeyboardSelectionListener.propTypes={// A "selection" event handler. 
// Will be passed the KeyboardEvent which triggered this "selection".
on_select:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Focusable__ = __webpack_require__(26);
var InvisibleButton=function InvisibleButton(_ref){var _ref$focus_ref=_ref.focus_ref,focus_ref=_ref$focus_ref===undefined?null:_ref$focus_ref,_ref$has_focus=_ref.has_focus,has_focus=_ref$has_focus===undefined?false:_ref$has_focus,_ref$on_select=_ref.on_select,on_select=_ref$on_select===undefined?null:_ref$on_select,_ref$left=_ref.left,left=_ref$left===undefined?'auto':_ref$left,_ref$right=_ref.right,right=_ref$right===undefined?'auto':_ref$right,_ref$top=_ref.top,top=_ref$top===undefined?'auto':_ref$top,_ref$bottom=_ref.bottom,bottom=_ref$bottom===undefined?'auto':_ref$bottom,width=_ref.width,height=_ref.height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{position:'absolute',left:left,right:right,top:top,bottom:bottom,width:width,height:height}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Focusable__["a" /* default */],{has_focus:has_focus,focus_ref:focus_ref,on_select:on_select},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:on_select,style:{width:width,height:height}})));};/* harmony default export */ __webpack_exports__["a"] = (InvisibleButton);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(53);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(36);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Returns an array of integers starting at a, incrementing by step, ending before b.
//
// Example:
//
// > var range = require("range").range;
// > range(0, 10);
// [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

function range(a, b, step) {
  if (arguments.length === 1) {
      b = a;
      a = 0;
  }

  step = step || 1;

  var x, r = [];

  for (x = a; (b - x) * step > 0; x += step) {
    r.push(x);
  }

  return r;
}

exports.range = range;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
module.exports = __webpack_require__(7).Array.find;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(147);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(156)('wks');
var uid = __webpack_require__(40);
var Symbol = __webpack_require__(6).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(43)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(22)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(157);
module.exports = __webpack_require__(7).Array.findIndex;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SOUNDon.6afcff98.png";

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return base_robot_images; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROBOT_VISUAL_STATES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Robot_css__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Robot_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Robot_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SoundManager_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_robots_01A_png__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_robots_01A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_robots_01A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_robots_02A_png__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_robots_02A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_robots_02A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_robots_03A_png__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_robots_03A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_robots_03A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_robots_04A_png__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_robots_04A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_robots_04A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_robots_05A_png__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_robots_05A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_robots_05A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_robots_06A_png__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_robots_06A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_robots_06A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_robots_07A_png__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_robots_07A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_robots_07A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_robots_08A_png__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_robots_08A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_robots_08A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_robots_09A_png__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_robots_09A_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_robots_09A_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_robots_01B_png__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_robots_01B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_robots_01B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_robots_02B_png__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_robots_02B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_robots_02B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_robots_03B_png__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_robots_03B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_robots_03B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_robots_04B_png__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_robots_04B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_robots_04B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_robots_05B_png__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_robots_05B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_robots_05B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_robots_06B_png__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_robots_06B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_robots_06B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_robots_07B_png__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_robots_07B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_robots_07B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_robots_08B_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_robots_08B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_robots_08B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_robots_09B_png__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_robots_09B_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_robots_09B_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_robots_01B2_png__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_robots_01B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_robots_01B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_robots_02B2_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_robots_02B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_robots_02B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_robots_03B2_png__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_robots_03B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_robots_03B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_robots_04B2_png__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_robots_04B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_robots_04B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_robots_05B2_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_robots_05B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_robots_05B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_robots_06B2_png__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_robots_06B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_robots_06B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_robots_07B2_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_robots_07B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_robots_07B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_robots_08B2_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_robots_08B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_robots_08B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_robots_09B2_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_robots_09B2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_robots_09B2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_robots_01C_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_robots_01C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_robots_01C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_robots_02C_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_robots_02C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_robots_02C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_robots_03C_png__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_robots_03C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_robots_03C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_robots_04C_png__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_robots_04C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_robots_04C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_robots_05C_png__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_robots_05C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__assets_robots_05C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__assets_robots_06C_png__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__assets_robots_06C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__assets_robots_06C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_robots_07C_png__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__assets_robots_07C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__assets_robots_07C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__assets_robots_08C_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__assets_robots_08C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__assets_robots_08C_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_robots_09C_png__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__assets_robots_09C_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__assets_robots_09C_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// This uses Webpack to bundle the files.
// For a comparison of this approach vs the public folder, see:
// https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-the-public-folder
var base_robot_images=[__WEBPACK_IMPORTED_MODULE_5__assets_robots_01A_png___default.a,__WEBPACK_IMPORTED_MODULE_6__assets_robots_02A_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_robots_03A_png___default.a,__WEBPACK_IMPORTED_MODULE_8__assets_robots_04A_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_robots_05A_png___default.a,__WEBPACK_IMPORTED_MODULE_10__assets_robots_06A_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_robots_07A_png___default.a,__WEBPACK_IMPORTED_MODULE_12__assets_robots_08A_png___default.a,__WEBPACK_IMPORTED_MODULE_13__assets_robots_09A_png___default.a];var robot_configs=[{image:__WEBPACK_IMPORTED_MODULE_5__assets_robots_01A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_14__assets_robots_01B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_23__assets_robots_01B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_32__assets_robots_01C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_6__assets_robots_02A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_15__assets_robots_02B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_24__assets_robots_02B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_33__assets_robots_02C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_7__assets_robots_03A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_16__assets_robots_03B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_25__assets_robots_03B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_34__assets_robots_03C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_8__assets_robots_04A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_17__assets_robots_04B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_26__assets_robots_04B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_35__assets_robots_04C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_9__assets_robots_05A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_18__assets_robots_05B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_27__assets_robots_05B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_36__assets_robots_05C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_10__assets_robots_06A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_19__assets_robots_06B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_28__assets_robots_06B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_37__assets_robots_06C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_11__assets_robots_07A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_20__assets_robots_07B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_29__assets_robots_07B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_38__assets_robots_07C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_12__assets_robots_08A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_21__assets_robots_08B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_30__assets_robots_08B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_39__assets_robots_08C_png___default.a},{image:__WEBPACK_IMPORTED_MODULE_13__assets_robots_09A_png___default.a,singing_image:__WEBPACK_IMPORTED_MODULE_22__assets_robots_09B_png___default.a,success_image:__WEBPACK_IMPORTED_MODULE_31__assets_robots_09B2_png___default.a,error_image:__WEBPACK_IMPORTED_MODULE_40__assets_robots_09C_png___default.a}];var ROBOT_VISUAL_STATES={DEFAULT:'default',SINGING:'singing',SUCCESS:'success',ERROR:'error'};var Robot=function(_Component){_inherits(Robot,_Component);function Robot(props){_classCallCheck(this,Robot);var _this=_possibleConstructorReturn(this,(Robot.__proto__||Object.getPrototypeOf(Robot)).call(this,props));_this.sound=null;return _this;}_createClass(Robot,[{key:'play_sound',value:function play_sound(sound_type){var _this2=this;var soundjs_options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};this.stop_sound();this.sound=Object(__WEBPACK_IMPORTED_MODULE_4__SoundManager_js__["e" /* playSound */])(sound_type,this.props.number,soundjs_options);this.sound.on('complete',function(){_this2.stop_sound();// the value of this.sound is used in display logic
_this2.forceUpdate();},null,true);}},{key:'stop_sound',value:function stop_sound(){if(this.sound){this.sound.stop();this.sound=null;}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this3=this;var _props=this.props,should_play_sound_once=_props.should_play_sound_once,is_playing_continuously=_props.is_playing_continuously;if(nextProps.is_playing_continuously&&!is_playing_continuously){this.play_sound(nextProps.long_sound?__WEBPACK_IMPORTED_MODULE_4__SoundManager_js__["a" /* SOUND_LONG */]:__WEBPACK_IMPORTED_MODULE_4__SoundManager_js__["b" /* SOUND_SHORT */],{loop:-1});}else if(is_playing_continuously&&!nextProps.is_playing_continuously){this.stop_sound();}// This check must come after is_playing_continuously, so that in a single 
// update we can stop continuous playback and initiate a single playback
if(nextProps.should_play_sound_once&&!should_play_sound_once){this.play_sound(nextProps.long_sound?__WEBPACK_IMPORTED_MODULE_4__SoundManager_js__["a" /* SOUND_LONG */]:__WEBPACK_IMPORTED_MODULE_4__SoundManager_js__["b" /* SOUND_SHORT */]);// Notice - this delays reading the value of on_sound_complete until the sound stops
this.sound.on('complete',function(){var on_sound_complete=_this3.props.on_sound_complete;if(on_sound_complete){on_sound_complete();}},null,true);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.stop_sound();}},{key:'get_src',value:function get_src(){var _props2=this.props,number=_props2.number,visual_state=_props2.visual_state;var config=robot_configs[number-1];switch(visual_state){case ROBOT_VISUAL_STATES.SINGING:return config.singing_image;case ROBOT_VISUAL_STATES.SUCCESS:return config.success_image;case ROBOT_VISUAL_STATES.ERROR:return config.error_image;}return config.image;}},{key:'render',value:function render(){var _props3=this.props,number=_props3.number,large=_props3.large;// const is_singing = Boolean(this.sound) || visually_singing;
// const config = robot_configs[number - 1];
// const src = error ? config.error_image : (is_singing ? config.singing_image : config.image);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.get_src(),alt:"Robot number "+number,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('Robot',{'Robot-small':!large})});}}]);return Robot;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["c"] = (Robot);Robot.propTypes={// all robots are identified by a number: 1 - 12
number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,large:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,// These affect audio only
// You must toggle this from false to true to make the robot play.
// Once started, there is no way to stop its sound.
should_play_sound_once:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,on_sound_complete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,is_playing_continuously:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,long_sound:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,visual_state:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,is_shaking:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Robot.defaultProps={visual_state:ROBOT_VISUAL_STATES.DEFAULT};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = onNextFrame;
/* harmony export (immutable) */ __webpack_exports__["a"] = getRandomElement;
/*
  Sometimes we want to do something like:
    - render state A
    - wait for browser to repaint
    - render state B
  (Ie. when changing a color, and then quickly using CSS transition to transition back to original color)

  We can call it from render/componentDidMount/componentDidUpdate, to ensure that the callback
  is only executed after the current DOM values have been painted.

  Note - depending on where the calling code is in the JS event loop, this function might actually wait one
  frame longer than necessary. 

  Do not use this function recursively to implement animations - use requestAnimationFrame directly for that.
*/function onNextFrame(callback){/*
    Note - the implementation discussed at https://stackoverflow.com/a/34999925 seems to work from render function
    when that render occurs as a result of calling setState in a React event handler.
    It doesn't work when setState is called from a timeout, however (in which case setState is processed
    synchronously).

    This implementation should always work (ie. wait until AT LEAST the current changes have been painted).
  *//*
    Note - it might be possible to make this work like Timer - as a component you render. We might be able to 
    render a button with a click listener, then programmatically create a click event (perhaps inside requestAnimationFrame).
    That would mean callback is executed from inside a React event handler, which means setState would have the
    usual asynchronous behaviour. I'm not sure if that has much advanatage, though, and it probably isn't worth the work.
  */requestAnimationFrame(function(){return requestAnimationFrame(callback);});}// error will be thrown if array is empty
function getRandomElement(array){var index=Math.floor(Math.random()*array.length);return array[index];}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(51);
module.exports = __webpack_require__(57);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(52).enable();
  window.Promise = __webpack_require__(55);
}

// fetch() polyfill for making API calls.
__webpack_require__(56);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(13);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(29);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 54 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(29);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppWrapper__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(326);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AppWrapper__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(13),n=__webpack_require__(30),p=__webpack_require__(10),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(60);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(61),B=__webpack_require__(13),C=__webpack_require__(10),ba=__webpack_require__(62),da=__webpack_require__(63),ea=__webpack_require__(64),fa=__webpack_require__(65),ia=__webpack_require__(68),D=__webpack_require__(30);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(10);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(66);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(67);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fscreen__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fscreen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppLoader__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppWrapper_css__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppWrapper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AppWrapper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WindowFitter_js__ = __webpack_require__(325);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
    IMPORTANT: react router's BrowserRouter doesn't work when the app is "Added to home screen"
    in Chrome. You have to use HashRouter instead. If desired, you can also, choose which 
    router to use depending on environment. See https://ayastreb.me/react-router-in-home-screen-pwa/
*//*
    The App component is designed with a fix width of 2048 x 1536.
    If we scale it directly, the coordinate system gets messed up (for drag and drop).
    However, if we put it inside an iframe and scale that iframe instead,
    it all works out perfectly (the iframe's 'window' coordinates are scaled automatically).
*/var AppIframeWrapper=function(_Component){_inherits(AppIframeWrapper,_Component);function AppIframeWrapper(props){_classCallCheck(this,AppIframeWrapper);var _this=_possibleConstructorReturn(this,(AppIframeWrapper.__proto__||Object.getPrototypeOf(AppIframeWrapper)).call(this,props));_this.requestFullscreen=function(){__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.requestFullscreen(_this.element);};_this.handle_fullscreen_change=function(event){_this.setState({should_generate_fullscreen_button:__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.fullscreenElement===null});};_this.handle_fullscreen_error=function(event){// TODO - error logging?
console.error(event);};var launched_from_home_screen=window.matchMedia&&window.matchMedia('(display-mode: fullscreen)').matches;_this.state={should_generate_fullscreen_button:__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.fullscreenEnabled&&__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.fullscreenElement===null&&!launched_from_home_screen};return _this;}_createClass(AppIframeWrapper,[{key:'componentDidMount',value:function componentDidMount(){if(__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.fullscreenEnabled){__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.addEventListener('fullscreenchange',this.handle_fullscreen_change);__WEBPACK_IMPORTED_MODULE_2_fscreen___default.a.addEventListener('fullscreenerror',this.handle_fullscreen_error);}}},{key:'generate_fullscreen_button',value:function generate_fullscreen_button(){// We've removed/disabled this feature
return null;// return <button onClick={this.requestFullscreen} style={{
//     position: 'absolute',
//     top: '20%',
//     right: '10%',
//     zIndex: '1',
// }}>Go Fullscreen</button>
}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(element){_this2.element=element;},className:'AppWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.should_generate_fullscreen_button?this.generate_fullscreen_button():null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__WindowFitter_js__["a" /* default */],{width:1024,height:768},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:'./index.html#app',title:'GleeBots game',style:{width:'1024px',height:'768px',border:'none',display:'block'}}))));}}]);return AppIframeWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var AppWrapper=function(_Component2){_inherits(AppWrapper,_Component2);function AppWrapper(){_classCallCheck(this,AppWrapper);return _possibleConstructorReturn(this,(AppWrapper.__proto__||Object.getPrototypeOf(AppWrapper)).apply(this,arguments));}_createClass(AppWrapper,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* HashRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/',component:AppIframeWrapper}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:'/app',component:__WEBPACK_IMPORTED_MODULE_3__AppLoader__["a" /* default */]})));}}]);return AppWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AppWrapper);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(72);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(34);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(79);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(82);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(85);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(87);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(35);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(16);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(93);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(95);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(97);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(98);
/* unused harmony reexport withRouter */



























/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(16);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(10);
var invariant = __webpack_require__(74);
var ReactPropTypesSecret = __webpack_require__(75);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(14);

var _PathUtils = __webpack_require__(4);

var _createTransitionManager = __webpack_require__(15);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(16);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(14);

var _PathUtils = __webpack_require__(4);

var _createTransitionManager = __webpack_require__(15);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(80);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(17);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(2);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(4);

var _LocationUtils = __webpack_require__(14);

var _createTransitionManager = __webpack_require__(15);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(34);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(84)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(86);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(88);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(89);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(90);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(91);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(92);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(5);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(37);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(37);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(19);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(94);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(96);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(18);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(18);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(99);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5
};

var webkit = ['webkitFullscreenEnabled', 'webkitFullscreenElement', 'webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitfullscreenchange', 'webkitfullscreenerror'];

var moz = ['mozFullScreenEnabled', 'mozFullScreenElement', 'mozRequestFullScreen', 'mozCancelFullScreen', 'mozfullscreenchange', 'mozfullscreenerror'];

var ms = ['msFullscreenEnabled', 'msFullscreenElement', 'msRequestFullscreen', 'msExitFullscreen', 'MSFullscreenChange', 'MSFullscreenError'];

// so it doesn't throw if no window or document
var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};

var vendor = 'fullscreenEnabled' in document && Object.keys(key) || webkit[0] in document && webkit || moz[0] in document && moz || ms[0] in document && ms || [];

exports.default = {
  requestFullscreen: function requestFullscreen(element) {
    return element[vendor[key.requestFullscreen]]();
  },
  requestFullscreenFunction: function requestFullscreenFunction(element) {
    return element[vendor[key.requestFullscreen]];
  },
  get exitFullscreen() {
    return document[vendor[key.exitFullscreen]].bind(document);
  },
  addEventListener: function addEventListener(type, handler, options) {
    return document.addEventListener(vendor[key[type]], handler, options);
  },
  removeEventListener: function removeEventListener(type, handler, options) {
    return document.removeEventListener(vendor[key[type]], handler, options);
  },
  get fullscreenEnabled() {
    return Boolean(document[vendor[key.fullscreenEnabled]]);
  },
  set fullscreenEnabled(val) {},
  get fullscreenElement() {
    return document[vendor[key.fullscreenElement]];
  },
  set fullscreenElement(val) {},
  get onfullscreenchange() {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(handler) {
    return document[('on' + vendor[key.fullscreenchange]).toLowerCase()] = handler;
  },
  get onfullscreenerror() {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(handler) {
    return document[('on' + vendor[key.fullscreenerror]).toLowerCase()] = handler;
  }
};

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SoundManager__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__KeyboardSelectionListener__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Robot__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Timer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_loading_page_LOADER_01_png__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_loading_page_LOADER_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_loading_page_LOADER_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_loading_page_LOADER_02_png__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_loading_page_LOADER_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_loading_page_LOADER_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_loading_page_LOADER_03_png__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_loading_page_LOADER_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_loading_page_LOADER_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_loading_page_LOADER_04_png__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_loading_page_LOADER_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_loading_page_LOADER_04_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_loading_page_LOADER_05_png__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_loading_page_LOADER_05_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_loading_page_LOADER_05_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_loading_page_LOADER_06_png__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_loading_page_LOADER_06_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_loading_page_LOADER_06_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_loading_page_LOADER_07_png__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_loading_page_LOADER_07_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_loading_page_LOADER_07_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_loading_page_LOADER_08_png__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_loading_page_LOADER_08_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_loading_page_LOADER_08_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_loading_page_LOADER_09_png__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_loading_page_LOADER_09_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_loading_page_LOADER_09_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_loading_page_LOADER_10_png__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_loading_page_LOADER_10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_loading_page_LOADER_10_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_loading_page_LOADER_11_png__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_loading_page_LOADER_11_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_loading_page_LOADER_11_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_loading_page_LOADER_12_png__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_loading_page_LOADER_12_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_loading_page_LOADER_12_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_loading_page_LOADERpage_BG_png__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_loading_page_LOADERpage_BG_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_loading_page_LOADERpage_BG_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// createjs is a globally included script
var createjs=window.createjs;var load_lights=[null,__WEBPACK_IMPORTED_MODULE_6__assets_loading_page_LOADER_01_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_loading_page_LOADER_02_png___default.a,__WEBPACK_IMPORTED_MODULE_8__assets_loading_page_LOADER_03_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_loading_page_LOADER_04_png___default.a,__WEBPACK_IMPORTED_MODULE_10__assets_loading_page_LOADER_05_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_loading_page_LOADER_06_png___default.a,__WEBPACK_IMPORTED_MODULE_12__assets_loading_page_LOADER_07_png___default.a,__WEBPACK_IMPORTED_MODULE_13__assets_loading_page_LOADER_08_png___default.a,__WEBPACK_IMPORTED_MODULE_14__assets_loading_page_LOADER_09_png___default.a,__WEBPACK_IMPORTED_MODULE_15__assets_loading_page_LOADER_10_png___default.a,__WEBPACK_IMPORTED_MODULE_16__assets_loading_page_LOADER_11_png___default.a,__WEBPACK_IMPORTED_MODULE_17__assets_loading_page_LOADER_12_png___default.a];var DOOR_STATES={OPEN:'open',CLOSING:'closing',OPENING:'opening',DONE:'done'};var AppLoader=function(_Component){_inherits(AppLoader,_Component);function AppLoader(props){_classCallCheck(this,AppLoader);var _this=_possibleConstructorReturn(this,(AppLoader.__proto__||Object.getPrototypeOf(AppLoader)).call(this,props));_this.state={loaded_loader_images:false,loaded_app_data:false,load_index:0,door_state:DOOR_STATES.OPEN};// loadAllSounds(() => {
//     // TODO - actually wait for sounds to load before starting?
//     // preload images?            
// });
return _this;}_createClass(AppLoader,[{key:'componentDidMount',value:function componentDidMount(){// this app loads in a iframe
// we need to focus the iframe
window.focus();}},{key:'on_background_load',value:function on_background_load(){var _this2=this;// Use preload js to preload all other "loader" images
var queue=new createjs.LoadQueue();queue.on('complete',function(){return _this2.on_loader_images_loaded();});queue.loadManifest([__WEBPACK_IMPORTED_MODULE_6__assets_loading_page_LOADER_01_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_loading_page_LOADER_02_png___default.a,__WEBPACK_IMPORTED_MODULE_8__assets_loading_page_LOADER_03_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_loading_page_LOADER_04_png___default.a,__WEBPACK_IMPORTED_MODULE_10__assets_loading_page_LOADER_05_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_loading_page_LOADER_06_png___default.a,__WEBPACK_IMPORTED_MODULE_12__assets_loading_page_LOADER_07_png___default.a,__WEBPACK_IMPORTED_MODULE_13__assets_loading_page_LOADER_08_png___default.a,__WEBPACK_IMPORTED_MODULE_14__assets_loading_page_LOADER_09_png___default.a,__WEBPACK_IMPORTED_MODULE_15__assets_loading_page_LOADER_10_png___default.a,__WEBPACK_IMPORTED_MODULE_16__assets_loading_page_LOADER_11_png___default.a,__WEBPACK_IMPORTED_MODULE_17__assets_loading_page_LOADER_12_png___default.a,__WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png___default.a,__WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png___default.a]);}},{key:'on_loader_images_loaded',value:function on_loader_images_loaded(){var _this3=this;// Now we want to initiate "load light" sequence, while preloading key app images
this.setState({loaded_loader_images:true});var queue=new createjs.LoadQueue();queue.on('complete',function(){return _this3.on_app_images_loaded();});queue.installPlugin(createjs.Sound);queue.loadManifest(__WEBPACK_IMPORTED_MODULE_4__Robot__["b" /* base_robot_images */]);queue.loadManifest(__WEBPACK_IMPORTED_MODULE_2__App__["b" /* initial_app_images */]);queue.loadManifest(__WEBPACK_IMPORTED_MODULE_1__SoundManager__["c" /* all_sounds */]);}},{key:'on_app_images_loaded',value:function on_app_images_loaded(){this.setState({loaded_app_data:true});}},{key:'render',value:function render(){var _this4=this;var _state=this.state,loaded_loader_images=_state.loaded_loader_images,loaded_app_data=_state.loaded_app_data,load_index=_state.load_index,door_state=_state.door_state;// First thing we do is display the background image
// Once it's fully loaded, we preload other loader images, then initiate load sequence
if(!loaded_loader_images){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App',autoFocus:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-layer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18__assets_loading_page_LOADERpage_BG_png___default.a,onLoad:function onLoad(e){return _this4.on_background_load();},style:{position:'absolute',top:0,left:0}})));}// begin rendering the app underneath the other layers before doors open
var app=null;if(load_index>11&&loaded_app_data){var start_robot_hand=door_state===DOOR_STATES.DONE;app=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */],{start_robot_hand:start_robot_hand});}// loading background/indicator - only if the "doors" aren't already closed
var loader=null;if(door_state==DOOR_STATES.OPEN||door_state==DOOR_STATES.CLOSING){var load_light_image=null;if(load_index){load_light_image=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:load_lights[load_index],style:{position:'absolute',bottom:0,left:0}});}loader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-layer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_18__assets_loading_page_LOADERpage_BG_png___default.a,style:{position:'absolute',top:0,left:0}}),load_light_image);}var left_door=null;var right_door=null;switch(door_state){case DOOR_STATES.OPEN:left_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png___default.a,className:'AppLoader-door AppLoader-door-left'});right_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png___default.a,className:'AppLoader-door AppLoader-door-right'});break;case DOOR_STATES.CLOSING:left_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png___default.a,className:'AppLoader-door'});right_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png___default.a,className:'AppLoader-door',style:{left:'0'},onTransitionEnd:function onTransitionEnd(){return _this4.setState({door_state:DOOR_STATES.OPENING});}});break;case DOOR_STATES.OPENING:// Don't actually open doors until we've pre loaded app images
if(!loaded_app_data){left_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png___default.a,className:'AppLoader-door'});right_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png___default.a,className:'AppLoader-door'});break;}left_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_loading_page_LOADERpage_Doorleft_png___default.a,className:'AppLoader-door AppLoader-door-left'});right_door=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_20__assets_loading_page_LOADERpage_Doorright_png___default.a,className:'AppLoader-door AppLoader-door-right',style:{left:'50'},onTransitionEnd:function onTransitionEnd(){return _this4.setState({door_state:DOOR_STATES.DONE});}});break;}var timer=null;if(door_state===DOOR_STATES.OPEN){if(load_index==load_lights.length-1){timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Timer__["a" /* default */],{delay:150,on_timeout:function on_timeout(){_this4.setState({door_state:DOOR_STATES.CLOSING});},reset_prevention_key:'doors_closing'});}else{timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Timer__["a" /* default */],{delay:150,on_timeout:function on_timeout(){_this4.setState({load_index:load_index+1});},reset_prevention_key:load_index});}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App',autoFocus:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{src:"."+'/cmf_tracking.html',width:'0',height:'0',frameBorder:'0'}),app,loader,left_door,right_door,timer);}}]);return AppLoader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AppLoader);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_01B.6fc2f140.mp3";

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_02B.1f804bcc.mp3";

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_03B.452c0683.mp3";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_04B.0f4c4a55.mp3";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_05B.3f58094e.mp3";

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_06B.45e5b2a7.mp3";

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_07B.7df19d41.mp3";

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_08B.a73eb544.mp3";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_09B.42c7abfe.mp3";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_01A.3b90e4e9.mp3";

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_02A.e9db0a40.mp3";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_03A.87827287.mp3";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_04A.37d3b1bb.mp3";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_05A.a1e1defc.mp3";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_06A.b15a0182.mp3";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_07A.ff8625e1.mp3";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_08A.91104f1b.mp3";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Koobot_Processed_09A.b94fcde1.mp3";

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/E_01_WIN.ae7050bf.mp3";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/E_01_FAIL.b9cad0e3.mp3";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-1.bb5737d5.mp3";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-2.e6f57523.mp3";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-3.f92cfab1.mp3";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-4.b1fcc3c6.mp3";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-5.52baa3e4.mp3";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-6.fc95c271.mp3";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-7.aed68648.mp3";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Positive-Clip-8.9a2f4f87.mp3";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Negative-Clip-1.fefaabf1.mp3";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Negative-Clip-2.e677d916.mp3";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Negative-Clip-3.c69743b2.mp3";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Negative-Clip-4.f68cfbe3.mp3";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Negative-Clip-5.f01d3bef.mp3";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DM-Negative-Clip-6.bcacf282.mp3";

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initial_app_images; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_some__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_fn_array_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_question_mark_svg__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_question_mark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_question_mark_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_layers_BACKwallBLANK_png__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_layers_BACKwallBLANK_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_layers_BACKwallBLANK_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_layers_LOAD_CONTROLbar_png__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_layers_LOAD_CONTROLbar_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_layers_LOAD_CONTROLbar_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_layers_PANELtop_png__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_layers_PANELtop_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_layers_PANELtop_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_layers_3targets_png__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_layers_3targets_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_layers_3targets_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_layers_4targets_png__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_layers_4targets_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_layers_4targets_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_layers_6targets_png__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_layers_6targets_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_layers_6targets_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_layers_SPOTlight_png__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_layers_SPOTlight_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_layers_SPOTlight_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_layers_SELECTstage3_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_layers_SELECTstage3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_layers_SELECTstage3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_layers_SELECTstage4_png__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_layers_SELECTstage4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_layers_SELECTstage4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_layers_SELECTstage6_png__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_layers_SELECTstage6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_layers_SELECTstage6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_SOUNDon_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_SOUNDon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_SOUNDon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_css__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Draggable__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Fader__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Focusable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__FocusManager__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AppCoordinateManager_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__HelpButton__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InvisibleButton__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__KeyboardHints__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__MagnetStrobeLayer__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__MuteButton__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__PlaceHolder__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ProgressBar__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Robot__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__RobotHand_js__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__StageControls__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Shaker__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Sound__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__SuccessLayer__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Timer_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__utils_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ZeroSizeCenterer__ = __webpack_require__(307);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// polyfills using core-js
// import  from './assets/layers/';
var initial_app_images=[__WEBPACK_IMPORTED_MODULE_6__assets_layers_BACKwallBLANK_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_layers_LOAD_CONTROLbar_png___default.a,__WEBPACK_IMPORTED_MODULE_8__assets_layers_PANELtop_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_layers_3targets_png___default.a,__WEBPACK_IMPORTED_MODULE_13__assets_layers_SELECTstage3_png___default.a,__WEBPACK_IMPORTED_MODULE_16__assets_SOUNDon_png___default.a];var active_level_buttons=[__WEBPACK_IMPORTED_MODULE_13__assets_layers_SELECTstage3_png___default.a,__WEBPACK_IMPORTED_MODULE_14__assets_layers_SELECTstage4_png___default.a,__WEBPACK_IMPORTED_MODULE_15__assets_layers_SELECTstage6_png___default.a];var LEVEL_BUTTON_WIDTH=143;var LEVEL_BUTTON_HEIGHT=87;var level_button_positions=[{left:546,top:614},{left:691,top:637},{left:834,top:615}];var BUTTON_INDECES=[0,1,2];/*
  This approach has advantages over simply wrapping Robot in <Shaker></Shaker> when we want it to shake.
  That approach means Robots will be unmounted/remounted whenever we add/remove the Shaker wrapper.
  This approach means the wrapper is always there, the component hierarchy doesn't change,
  so the Robot will never have to re-mount.
*/var Robot=Object(__WEBPACK_IMPORTED_MODULE_35__Shaker__["a" /* Shakeable */])(__WEBPACK_IMPORTED_MODULE_32__Robot__["c" /* default */]);// DEBUG
var DISABLE_HAND=false;function array_contains(array,element){return array.find(function(e){return e===element;})!==undefined;}var panel_indeces=[0,1,2,3,4,5,6,7,8];var robot_indeces=[0,1,2,3,4,5,6,7,8];function fillSequence(sequence,to_number_of_notes,with_stage_count){for(var i=to_number_of_notes-sequence.length;i>0;i--){sequence.push(Math.floor(Math.random()*with_stage_count));}}function getPreparedSequence(current_sequence,level,sequence_number){var new_sequence=current_sequence.slice();fillSequence(new_sequence,level.notes_per_sequence[sequence_number-1],level.stage_count);return new_sequence;}// given number of robots on stage, how many are on one row
var stage_row_widths={'3':3,'4':3,'6':3};function location_descriptions_are_equal(d1,d2){return d1.area===d2.area&&d1.index===d2.index;}function panel_focus_key(panel_index){return'panel '+panel_index;}function stage_focus_key(stage_index){return'stage '+stage_index;}function level_control_key(button_index){return'level button '+button_index;}var panel_place_holder_half_width=45;function makePanelLocation(x,y){return{center:{left:x,top:y},upper_left:{left:x-panel_place_holder_half_width,top:y-panel_place_holder_half_width},lower_right:{left:x+panel_place_holder_half_width,top:y+panel_place_holder_half_width}};}var panel_locations=[makePanelLocation(75,63),makePanelLocation(177,68),makePanelLocation(279,66),makePanelLocation(394,66),makePanelLocation(510,66),makePanelLocation(620,66),makePanelLocation(731,66),makePanelLocation(846,66),makePanelLocation(949,66)];var stage_place_holder_half_width=90;function makeStageLocation(x,y){return{center:{left:x,top:y},upper_left:{left:x-stage_place_holder_half_width,top:y-stage_place_holder_half_width},lower_right:{left:x+stage_place_holder_half_width,top:y+stage_place_holder_half_width}};}var stage_locations_by_level=[[makeStageLocation(307,398),makeStageLocation(517,448),makeStageLocation(746,399)],[makeStageLocation(312,278),makeStageLocation(523,245),makeStageLocation(737,300),makeStageLocation(514,471)],[makeStageLocation(290,276),makeStageLocation(495,286),makeStageLocation(697,283),makeStageLocation(291,503),makeStageLocation(500,492),makeStageLocation(698,490)]];var stage_images=[__WEBPACK_IMPORTED_MODULE_9__assets_layers_3targets_png___default.a,__WEBPACK_IMPORTED_MODULE_10__assets_layers_4targets_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_layers_6targets_png___default.a];// sub-states of REPEATING_SEQUENCE
// we could be in any one of these states for any given note in the sequence
var REPEATING_STATES={// Note number is the one the user should hit
WAITING_FOR_INPUT:'waiting',// Note number is the one the user just hit
// Make robot sing
// Go immediately to indicating success
STARTING_NOTE:'starting note',// Note number is the one the user just hit
// On sound complete, advance note number and go to WAITING_FOR_INPUT
// On successful selection (which is the NEXT note number), advance note number and go to STARTING_NOTE
INDICATING_SUCCESS:'indicating success'};var PLAYING_STATES={PAUSED_BEFORE_STARTING_SEQUENCE:'paused before starting sequence',STARTING_NOTE:'starting note',ENDING_NOTE:'ending note'};var HELPING_HAND_STATES={// help button not on screen, hand not on screen
NONE:'none',// help button has appeared, indicating that help is available, but user has not yet clicked it
AVAILABLE:'available',/*
    These represent the various sequences the hand performs.
    Most of these states could be replace by a general "active" flag,
    and other app state properties could be used to determine which 
    help sequence is active. However, there are a few app states which 
    could actually be showing different help sequences, so we just 
    give each sequence a separate flag to be safe.
  */MOVE_ROBOT:'move robot',PRESS_PLAY:'press play',TAP_CORRECT_ROBOT:'tap correct robot',TAP_RESET_BUTTON:'tap reset button',TAP_NEXT_LEVEL:'tap next level'};var FOCUS_ROWS={PANEL:0,// 1.x reserved for stage
// 1.0 -> stage 1
// 1.1 -> stage 2
HELP_BUTTON:1.0,MUTE_CONTROLS:1.0,PLAYBACK_CONTROLS:1.1,LEVEL_CONTROLS:4};function stage_focus_row(stage_row){return 1+stage_row/10;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.on_user_repeated_while_idle=function(stage_index){_this.cancel_any_available_help();var expected_index=_this.expectedStageIndex();if(stage_index===expected_index){_this.setState({repeating_state:REPEATING_STATES.STARTING_NOTE});}else{_this.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FAILURE});}};_this.on_user_repeated_while_indicating_success=function(stage_index){var note_number=_this.state.note_number;_this.cancel_any_available_help();var expected_index=_this.expectedStageIndex();if(stage_index===expected_index){_this.setState({note_number:note_number+1,repeating_state:REPEATING_STATES.STARTING_NOTE});}else{_this.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FAILURE});}};_this.advance_hand=function(){_this.setState({hand_substate:_this.state.hand_substate+1});};_this.focusManager=new __WEBPACK_IMPORTED_MODULE_23__FocusManager__["a" /* default */](function(focused_item_key){return _this.setState({focused_item_key:focused_item_key});});_this.level_buttons=[];_this.state={is_first_time_in_filling_stage_phase:__WEBPACK_IMPORTED_MODULE_19__config__["b" /* START_HAND_IMMEDIATELY */],muted:false,// for keyboard navigation
focused_item_key:null,game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FILLING_STAGE,magnet_strobe_index:0,level_index:0,// which note in the current sequence are we playing. 1 - X
// Used during both playing and repeating stages
note_number:null,// which sequence in the current level are we playing. 1 - Y
sequence_number:null,// array of stage indeces for the notes in the current sequence
// grows with every sequence
current_sequence:null,// during PLAYING_SEQUENCE, this must be one of the PLAYING_STATES
playing_state:null,// during REPEATING_SEQUENCE, this must be one of the REPEATING_STATES
repeating_state:null,/*
        'location' here is a poor choice of words.
        This is really a description of where the robot is, relative to other elements.
        It describes which placeholder (in PANEL or STAGE) each Robot is tied to.
      */robot_locations:robot_indeces.map(function(robot_index){return{area:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */],index:robot_index};}),selected_robot:null,// if a robot is being dragged over a PlaceHolder and is ready to be dropped,
// this identifies that PlaceHolder 
hovered_placeholder:null,// all help/helping hand state properties will begin with "hand_"
// we won't initialize them all here - we'll just set them as needed
hand_state:HELPING_HAND_STATES.NONE,/*
        this is used to help reset the timer when switching between two states
        which both render the same timer (ie. when switching levels while in 
        filling stage phase). In those cases, increment this counter to ensure
        the timer is reset
      */hand_timeout_counter:0};// See focusable_function for usage.
_this.focus_functions={};return _this;}_createClass(App,[{key:'shows_keyboard_focus',value:function shows_keyboard_focus(){switch(this.state.hand_state){case HELPING_HAND_STATES.NONE:case HELPING_HAND_STATES.AVAILABLE:return true;}return false;}/*
    Helper for registering elements with focus manager.
    This must return the same function when invoked with the same parameters.
    The returned function will end up being passed to an element's ref attribute,
    and if it's not the exact same function, the element will end up being 
    de-registered and then registered again with focusManager on each render.
  */},{key:'focusable_function',value:function focusable_function(key,row_level){var _this2=this;this.focus_functions[row_level]=this.focus_functions[row_level]||{};this.focus_functions[row_level][key]=this.focus_functions[row_level][key]||function(element){_this2.focusManager.register(key,row_level,element);};return this.focus_functions[row_level][key];}},{key:'stage_focus_function',value:function stage_focus_function(stage_index){// determine which row of stage this placeholder is in
var level_index=this.state.level_index;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var robots_per_row=stage_row_widths[level.stage_count];var row_index=Math.floor(stage_index/robots_per_row);return this.focusable_function(stage_focus_key(stage_index),stage_focus_row(row_index));}// programmatically click a placeholder - used for helping hand stuff
// note - the "React way" of doing this would be to get a ref from each PlaceHolder,
// but this works and is simpler. Just might have to updated if we update PlaceHolder 
},{key:'click_placeholder',value:function click_placeholder(location){var container_class=location.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */]?'#App-panel-placeholders':'#App-stage-placeholders';this.app_element.querySelectorAll(container_class+' .PlaceHolder-click-target')[location.index].click();}},{key:'get_stage_control_button',value:function get_stage_control_button(){return this.app_element.querySelector('.StageControls-button');}/////////////////////////////////////////////////////////////////////////////
// General game control
/////////////////////////////////////////////////////////////////////////////
},{key:'robotLocationsUpdatedForLevel',value:function robotLocationsUpdatedForLevel(level_index){var robot_locations=this.state.robot_locations;var stage_locations=stage_locations_by_level[level_index];var new_robot_locations=robot_locations.slice();var stage_count=stage_locations.length;// iterate through new_robot_locations, moving robots to panel as necessary
for(var robot_index=new_robot_locations.length-1;robot_index>=0;robot_index--){var location=new_robot_locations[robot_index];if(location.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]&&location.index>=stage_count){// move robot to an available panel location
// find first panel index where no robot is in that location
var panel_index=panel_indeces.find(function(panel_index){return!new_robot_locations.some(function(location){return location.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */]&&location.index===panel_index;});});new_robot_locations[robot_index]={area:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */],index:panel_index};}}return new_robot_locations;}},{key:'select_placeholder_during_filling_stage',value:function select_placeholder_during_filling_stage(placeholder_descriptor){var _state=this.state,selected_robot=_state.selected_robot,robot_locations=_state.robot_locations;var new_robot=robot_locations.findIndex(function(l){return location_descriptions_are_equal(l,placeholder_descriptor);});this.restart_help_timer();// if the clicked a different robot, select it instead
if(new_robot>=0){this.setState({selected_robot:new_robot});}// they clicked an empty placeholder. 
else if(selected_robot!==null){var new_locations=robot_locations.slice();new_locations[selected_robot]=placeholder_descriptor;this.setState({robot_locations:new_locations,selected_robot:null});// if they moved a robot to stage, cancel help button - they are on the right track
if(placeholder_descriptor.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]){this.cancel_any_available_help();}}}/////////////////////////////////////////////////////////////////////////////
// Sequence playback logic
/////////////////////////////////////////////////////////////////////////////
},{key:'startLevel',value:function startLevel(level){this.setState({selected_robot:null});this.startSequence(level,[],1);}},{key:'startSequence',value:function startSequence(level,current_sequence,sequence_number){var new_sequence=getPreparedSequence(current_sequence,level,sequence_number);this.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].PLAYING_SEQUENCE,playing_state:PLAYING_STATES.PAUSED_BEFORE_STARTING_SEQUENCE,current_sequence:new_sequence,sequence_number:sequence_number,note_number:1});}},{key:'expectedStageIndex',value:function expectedStageIndex(){var _state2=this.state,current_sequence=_state2.current_sequence,note_number=_state2.note_number,repeating_state=_state2.repeating_state;if(repeating_state===REPEATING_STATES.INDICATING_SUCCESS){return current_sequence[note_number];}return current_sequence[note_number-1];}},{key:'getCoordinatesOfRobotPlaceHolder',/////////////////////////////////////////////////////////////////////////////
// Robot location management
/////////////////////////////////////////////////////////////////////////////
value:function getCoordinatesOfRobotPlaceHolder(robot_index){var level_index=this.state.level_index;var stage_locations=stage_locations_by_level[level_index];var robot_location=this.state.robot_locations[robot_index];var locations=robot_location.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */]?panel_locations:stage_locations;return locations[robot_location.index].center;}},{key:'stage_is_full',value:function stage_is_full(robot_locations){var level_index=this.state.level_index;var stage_locations=stage_locations_by_level[level_index];var filled_stage_count=0;robot_locations.forEach(function(location){if(location.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]){filled_stage_count++;}});return filled_stage_count===stage_locations.length;}// calculate array mapping stage locations -> robot in that position (if any)
},{key:'get_stage_robots',value:function get_stage_robots(){var _state3=this.state,level_index=_state3.level_index,robot_locations=_state3.robot_locations;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];// initialize array of nulls
var stage_robots=level.stage_indeces.map(function(index){return null;});for(var robot_index=robot_locations.length-1;robot_index>=0;robot_index--){var location=robot_locations[robot_index];if(location.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]){stage_robots[location.index]=robot_index;}}return stage_robots;}},{key:'robot_for_stage_index',value:function robot_for_stage_index(stage_index){return this.get_stage_robots()[stage_index];}/////////////////////////////////////////////////////////////////////////////
// Helping hand stuff
/////////////////////////////////////////////////////////////////////////////
},{key:'create_help_timer',value:function create_help_timer(help_type){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:4000,on_timeout:function on_timeout(){return _this3.setState({hand_state:HELPING_HAND_STATES.AVAILABLE});},reset_prevention_key:help_type+this.state.hand_timeout_counter});}// call this after a "successful" interaction which indicates user is on right track,
// but when the same help will ultimately be available if user pauses
},{key:'restart_help_timer',value:function restart_help_timer(){var hand_timeout_counter=this.state.hand_timeout_counter;this.setState({hand_timeout_counter:hand_timeout_counter+1});}},{key:'prepare_for_helping_hand',value:function prepare_for_helping_hand(){// We might want to alter various state properties while hand is helping.
// Here, we backup current state so we can reset it after hand is done.
// shallow copy current state
this.state_before_helping_hand=Object.assign({},this.state);this.setState({hand_substate:0});}},{key:'cancel_helping_hand',value:function cancel_helping_hand(){this.setState(this.state_before_helping_hand);this.setState({hand_state:HELPING_HAND_STATES.NONE});this.state_before_helping_hand=null;}},{key:'make_hand_move_robot_to_stage',value:function make_hand_move_robot_to_stage(){this.prepare_for_helping_hand();var _state4=this.state,level_index=_state4.level_index,robot_locations=_state4.robot_locations;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];// find a random robot in the panel
var panel_robot_indeces=robot_indeces.filter(function(robot_index){return robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */];});var robot_index_to_move=Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["a" /* getRandomElement */])(panel_robot_indeces);// find a random open stage position
var stage_robots=this.get_stage_robots();var open_stage_indeces=level.stage_indeces.filter(function(stage_index){return stage_robots[stage_index]===null;});var stage_index_to_move_to=Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["a" /* getRandomElement */])(open_stage_indeces);this.setState({'hand_state':HELPING_HAND_STATES.MOVE_ROBOT,'hand_should_move_robot':robot_index_to_move,'hand_should_move_robot_to_stage_position':stage_index_to_move_to});}},{key:'cancel_any_available_help',value:function cancel_any_available_help(){// various "successful" interactions should cause the help button to disappear, if present
// when those occur, call this method
var hand_state=this.state.hand_state;if(hand_state===HELPING_HAND_STATES.AVAILABLE){this.setState({hand_state:HELPING_HAND_STATES.NONE});}}},{key:'getBasicRobots',/////////////////////////////////////////////////////////////////////////////
// Rendering functions
/////////////////////////////////////////////////////////////////////////////
value:function getBasicRobots(){var error=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var robot_locations=this.state.robot_locations;var visual_state=error?__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].ERROR:__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].DEFAULT;return robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Robot,{visual_state:visual_state,number:robot_index+1,large:robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]});});}},{key:'render_hand_moving_and_clicking',value:function render_hand_moving_and_clicking(final_position){var _this4=this;var hand_substate=this.state.hand_substate;var initial_position={top:225,left:200};var movement_transition='top 1s ease-in-out, left 1s ease-in-out';if(hand_substate===0){Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(this.advance_hand);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:initial_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}else if(hand_substate===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:initial_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true,on_transition_end:this.advance_hand},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}else if(hand_substate===2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:final_position,transition:movement_transition,on_transition_end:this.advance_hand},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}else if(hand_substate===3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:final_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:300,on_timeout:this.advance_hand,reset_prevention_key:hand_substate}));}else if(hand_substate===4){Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(this.advance_hand);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:final_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}else if(hand_substate===5){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:final_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:false,on_transition_end:function on_transition_end(){return _this4.setState({hand_state:HELPING_HAND_STATES.NONE,hand_substate:0});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}}},{key:'render_filling',value:function render_filling(){var _this5=this;var _state5=this.state,selected_robot=_state5.selected_robot,level_index=_state5.level_index,robot_locations=_state5.robot_locations,focused_item_key=_state5.focused_item_key,hand_state=_state5.hand_state,hand_substate=_state5.hand_substate,hand_should_move_robot=_state5.hand_should_move_robot,hand_should_move_robot_to_stage_position=_state5.hand_should_move_robot_to_stage_position,is_first_time_in_filling_stage_phase=_state5.is_first_time_in_filling_stage_phase;if(is_first_time_in_filling_stage_phase&&this.props.start_robot_hand){Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(function(){_this5.setState({is_first_time_in_filling_stage_phase:false});_this5.make_hand_move_robot_to_stage();});}var stage_locations=stage_locations_by_level[level_index];var selected_placeholder=selected_robot!==null?robot_locations[selected_robot]:null;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var stage_is_full=this.stage_is_full(robot_locations);var robots=robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Robot,{shaking:// robot_index !== selected_robot
selected_robot===null,number:robot_index+1,large:robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */],should_play_sound_once:robot_index===selected_robot,visual_state:robot_index===selected_robot?__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].SINGING:__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].DEFAULT,long_sound:true});});var located_robots=robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{key:robot_index,draggable:false// turn off transitions when robot is NOT being dropped by user 
// (this only affects robot being reset after helping hand drags one to stage)
,transition:true?undefined:'none',initial_coords:_this5.getCoordinatesOfRobotPlaceHolder(robot_index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__ZeroSizeCenterer__["a" /* default */],null,robots[robot_index]));});var help_callback=null;var helping_hand=null;var help_timeout=null;var state_transition_timeout=null;if(hand_state===HELPING_HAND_STATES.NONE){if(!stage_is_full){help_timeout=this.create_help_timer("robot_drag_to_stage");}else{help_timeout=this.create_help_timer("press play button");}}else if(hand_state===HELPING_HAND_STATES.AVAILABLE){if(!stage_is_full){help_callback=function help_callback(){return _this5.make_hand_move_robot_to_stage();};}else{help_callback=function help_callback(){return _this5.setState({hand_state:HELPING_HAND_STATES.PRESS_PLAY,hand_substate:0});};}}else if(hand_state===HELPING_HAND_STATES.MOVE_ROBOT){// where on screen the hand should appear
// we could also just have it move in from off-screen
var initial_position={top:225,left:200};var movement_transition='top 1s ease-in-out, left 1s ease-in-out';var panel_position=panel_locations[robot_locations[hand_should_move_robot].index].center;var stage_position=stage_locations[hand_should_move_robot_to_stage_position].center;if(hand_substate===0){Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(this.advance_hand);helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:initial_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],null)));}else if(hand_substate===1){helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:initial_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true,on_transition_end:this.advance_hand},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],null)));}else if(hand_substate===2){helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:panel_position,transition:movement_transition,on_transition_end:this.advance_hand},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],null)));}else if(hand_substate===3){if(selected_robot!==hand_should_move_robot){Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(function(){return _this5.click_placeholder(robot_locations[hand_should_move_robot]);});}else{state_transition_timeout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:300,on_timeout:this.advance_hand,reset_prevention_key:"move_hand_to_stage"});}helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:panel_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:true})));}else if(hand_substate===4){helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:stage_position,transition:movement_transition,on_transition_end:this.advance_hand},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}else if(hand_substate===5){// if we haven't moved robot yet
if(robot_locations[hand_should_move_robot].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */]){var placeholder={area:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */],index:hand_should_move_robot_to_stage_position};Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(function(){return _this5.click_placeholder(placeholder);});}else{state_transition_timeout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:300,on_timeout:this.advance_hand,reset_prevention_key:'make hand disappear'});}helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:stage_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:true})));}else if(hand_substate===6){helping_hand=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{draggable:false,initial_coords:stage_position},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Fader__["a" /* default */],{visible:false,on_transition_end:function on_transition_end(){return _this5.cancel_helping_hand();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__RobotHand_js__["a" /* default */],{is_clicking:false})));}}else if(hand_state===HELPING_HAND_STATES.PRESS_PLAY){var play_position=Object(__WEBPACK_IMPORTED_MODULE_24__AppCoordinateManager_js__["a" /* default */])(this.get_stage_control_button()).center;helping_hand=this.render_hand_moving_and_clicking(play_position);}var play_function=function play_function(){return _this5.startLevel(level);};return this.render_app({help_callback:help_callback,help_timeout:help_timeout,helping_hand:helping_hand,state_transition_timeout:state_transition_timeout,located_robots:located_robots,magnets_pulsing:selected_robot!==null,panel_place_holders:panel_indeces.map(function(panel_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{focus_child_ref_func:_this5.focusable_function(panel_focus_key(panel_index),FOCUS_ROWS.PANEL),has_focus:_this5.shows_keyboard_focus()&&focused_item_key===panel_focus_key(panel_index),is_hovered:selected_placeholder&&selected_placeholder.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */]&&selected_placeholder.index===panel_index,should_transition_to_current_color:false,on_select:function on_select(){return _this5.select_placeholder_during_filling_stage({area:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["b" /* PANEL */],index:panel_index});}});}),stage_place_holders:level.stage_indeces.map(function(stage_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{focus_child_ref_func:_this5.stage_focus_function(stage_index),has_focus:_this5.shows_keyboard_focus()&&focused_item_key===stage_focus_key(stage_index),is_hovered:selected_placeholder&&selected_placeholder.area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]&&selected_placeholder.index===stage_index,should_transition_to_current_color:false,on_select:function on_select(){return _this5.select_placeholder_during_filling_stage({area:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */],index:stage_index});}});}),stage_controls:stage_is_full?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__StageControls__["b" /* default */],{button:__WEBPACK_IMPORTED_MODULE_34__StageControls__["a" /* STAGE_CONTROL_BUTTONS */].PLAY,focus_ref:this.focusable_function('play_button',FOCUS_ROWS.PLAYBACK_CONTROLS),has_focus:this.shows_keyboard_focus()&&focused_item_key==='play_button',on_select:play_function}):null});}},{key:'render_playing',value:function render_playing(){var _this6=this;var _state6=this.state,playing_state=_state6.playing_state,level_index=_state6.level_index,sequence_number=_state6.sequence_number,current_sequence=_state6.current_sequence,note_number=_state6.note_number,robot_locations=_state6.robot_locations;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var active_robot_index=this.robot_for_stage_index(current_sequence[note_number-1]);var playing_robot_index=null;var visually_singing_index=null;var should_transition_to_current_color=true;var state_transition_timeout=null;var progress_note_number=note_number;var on_sound_complete=function on_sound_complete(){};switch(playing_state){case PLAYING_STATES.PAUSED_BEFORE_STARTING_SEQUENCE:progress_note_number=0;state_transition_timeout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:500,on_timeout:function on_timeout(){return _this6.setState({playing_state:PLAYING_STATES.STARTING_NOTE});},reset_prevention_key:"play_first_note"});break;case PLAYING_STATES.STARTING_NOTE:should_transition_to_current_color=false;playing_robot_index=active_robot_index;visually_singing_index=active_robot_index;on_sound_complete=function on_sound_complete(){return _this6.setState({playing_state:PLAYING_STATES.ENDING_NOTE});};// onNextFrame(() => this.setState({
//   playing_state: PLAYING_STATES.ENDING_NOTE,
// }));
break;case PLAYING_STATES.ENDING_NOTE:// visually_singing_index = active_robot_index;
if(note_number<current_sequence.length){state_transition_timeout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:200,on_timeout:function on_timeout(){return _this6.setState({playing_state:PLAYING_STATES.STARTING_NOTE,note_number:note_number+1});},reset_prevention_key:"play_note_after_"+note_number});}else{state_transition_timeout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:200,on_timeout:function on_timeout(){return _this6.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].REPEATING_SEQUENCE,note_number:1,repeating_state:REPEATING_STATES.WAITING_FOR_INPUT});},reset_prevention_key:"go_to_repeating"});}break;default:break;}return this.render_app({state_transition_timeout:state_transition_timeout,progress_bar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ProgressBar__["a" /* default */],{level:level_index,current_playback_length:progress_note_number}),robots:robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Robot,{number:robot_index+1,should_play_sound_once:robot_index===playing_robot_index,on_sound_complete:on_sound_complete,visual_state:robot_index===visually_singing_index?__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].SINGING:__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].DEFAULT,large:robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]});}),panel_place_holders:panel_indeces.map(function(panel_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:panel_index});}),stage_place_holders:level.stage_indeces.map(function(stage_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:stage_index,should_transition_to_current_color:should_transition_to_current_color});})});}},{key:'render_repeating',value:function render_repeating(){var _this7=this;var _state7=this.state,repeating_state=_state7.repeating_state,level_index=_state7.level_index,sequence_number=_state7.sequence_number,current_sequence=_state7.current_sequence,note_number=_state7.note_number,robot_locations=_state7.robot_locations,focused_item_key=_state7.focused_item_key,hand_state=_state7.hand_state;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var stage_locations=stage_locations_by_level[level_index];var help_callback=null;if(hand_state===HELPING_HAND_STATES.AVAILABLE){help_callback=function help_callback(){return _this7.setState({hand_state:HELPING_HAND_STATES.TAP_CORRECT_ROBOT,hand_substate:0});};}var help_timeout=null;if(hand_state===HELPING_HAND_STATES.NONE){if(repeating_state===REPEATING_STATES.WAITING_FOR_INPUT){help_timeout=this.create_help_timer("tap_correct_robot");}}var helping_hand=null;if(hand_state!==HELPING_HAND_STATES.NONE&&hand_state!==HELPING_HAND_STATES.AVAILABLE){var final_position=stage_locations[this.expectedStageIndex()].center;helping_hand=this.render_hand_moving_and_clicking(final_position);}var visually_singing_index=null;if(repeating_state===REPEATING_STATES.INDICATING_SUCCESS||repeating_state===REPEATING_STATES.STARTING_NOTE){visually_singing_index=this.robot_for_stage_index(current_sequence[note_number-1]);}var singing_index=null;if(repeating_state===REPEATING_STATES.STARTING_NOTE){singing_index=this.robot_for_stage_index(current_sequence[note_number-1]);}if(repeating_state===REPEATING_STATES.STARTING_NOTE){Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(function(){return _this7.setState({repeating_state:REPEATING_STATES.INDICATING_SUCCESS});});}var on_sound_complete=null;if(repeating_state===REPEATING_STATES.INDICATING_SUCCESS){if(note_number===current_sequence.length){on_sound_complete=function on_sound_complete(){return _this7.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].SEQUENCE_SUCCESS});};}else{on_sound_complete=function on_sound_complete(){return _this7.setState({repeating_state:REPEATING_STATES.WAITING_FOR_INPUT,note_number:note_number+1});};}}var on_stage_select=function on_stage_select(){};if(repeating_state===REPEATING_STATES.WAITING_FOR_INPUT){var expected_index=current_sequence[note_number-1];on_stage_select=function on_stage_select(index){_this7.cancel_any_available_help();if(index===expected_index){_this7.setState({repeating_state:REPEATING_STATES.STARTING_NOTE});}else{_this7.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FAILURE});}};}if(repeating_state===REPEATING_STATES.INDICATING_SUCCESS&&note_number<current_sequence.length){var _expected_index=current_sequence[note_number];on_stage_select=function on_stage_select(index){_this7.cancel_any_available_help();if(index===_expected_index){_this7.setState({repeating_state:REPEATING_STATES.STARTING_NOTE,note_number:note_number+1});}else{_this7.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FAILURE});}};}var progress_bar_success_length=repeating_state==REPEATING_STATES.WAITING_FOR_INPUT?note_number-1:note_number;return this.render_app({help_callback:help_callback,helping_hand:helping_hand,help_timeout:help_timeout,show_stage_question_mark:true,progress_bar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ProgressBar__["a" /* default */],{level:level_index,current_input_length:progress_bar_success_length}),robots:robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Robot,{number:robot_index+1,should_play_sound_once:robot_index===singing_index,visual_state:robot_index===visually_singing_index?__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].SUCCESS:__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].DEFAULT,on_sound_complete:robot_index===visually_singing_index?on_sound_complete:null,large:robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */],shaking:robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */]});}),panel_place_holders:panel_indeces.map(function(panel_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:panel_index});}),stage_place_holders:level.stage_indeces.map(function(stage_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:stage_index,focus_child_ref_func:_this7.stage_focus_function(stage_index),has_focus:_this7.shows_keyboard_focus()&&focused_item_key===stage_focus_key(stage_index),on_select:on_stage_select.bind(null,stage_index)});})});}},{key:'render_sequence_success',value:function render_sequence_success(){var _this8=this;var _state8=this.state,sequence_number=_state8.sequence_number,level_index=_state8.level_index,current_sequence=_state8.current_sequence,note_number=_state8.note_number;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var state_transition_timeout=null;if(sequence_number===level.notes_per_sequence.length){// go immediately to level success
// The current state isn't strictly necessary, but the logic is made a lot simpler by including it.
// TODO - is this a race condition? What if user clicks level change button before this fires? (which is essentially impossible)
// Maybe onNextFrame should be refactored
Object(__WEBPACK_IMPORTED_MODULE_39__utils_js__["b" /* onNextFrame */])(function(){return _this8.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].LEVEL_SUCCESS});});}else{// Nothing special in this state. Just a wait a little bit before going to next sequence.
// Maybe we'll want to play a sound in this state.
state_transition_timeout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__Timer_js__["a" /* default */],{delay:0,on_timeout:function on_timeout(){return _this8.startSequence(level,current_sequence,sequence_number+1);},reset_prevention_key:'go_to_next_sequence'});}return this.render_app({state_transition_timeout:state_transition_timeout,progress_bar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ProgressBar__["a" /* default */],{level:level_index,current_input_length:0}),robots:this.getBasicRobots(),panel_place_holders:panel_indeces.map(function(panel_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:panel_index,should_transition_to_current_color:false});}),stage_place_holders:level.stage_indeces.map(function(stage_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:stage_index});})});}},{key:'render_failure',value:function render_failure(){var _this9=this;var _state9=this.state,level_index=_state9.level_index,focused_item_key=_state9.focused_item_key,hand_state=_state9.hand_state;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var reset=function reset(){_this9.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FILLING_STAGE});_this9.cancel_any_available_help();};var help_callback=null;var helping_hand=null;var help_timeout=null;if(hand_state===HELPING_HAND_STATES.NONE){help_timeout=this.create_help_timer("tap reset button");}else if(hand_state===HELPING_HAND_STATES.AVAILABLE){help_callback=function help_callback(){return _this9.setState({hand_state:HELPING_HAND_STATES.TAP_RESET_BUTTON,hand_substate:0});};}else{var final_position=Object(__WEBPACK_IMPORTED_MODULE_24__AppCoordinateManager_js__["a" /* default */])(this.get_stage_control_button()).center;helping_hand=this.render_hand_moving_and_clicking(final_position);}return this.render_app({help_timeout:help_timeout,help_callback:help_callback,helping_hand:helping_hand,robots:this.getBasicRobots(true),panel_place_holders:panel_indeces.map(function(panel_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:panel_index,is_error:true});}),stage_place_holders:level.stage_indeces.map(function(stage_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:stage_index,is_error:true});}),stage_controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__StageControls__["b" /* default */],{button:__WEBPACK_IMPORTED_MODULE_34__StageControls__["a" /* STAGE_CONTROL_BUTTONS */].RESET,focus_ref:this.focusable_function('play_button',FOCUS_ROWS.PLAYBACK_CONTROLS),has_focus:this.shows_keyboard_focus()&&focused_item_key==='play_button',on_select:reset})});}},{key:'render_level_success',value:function render_level_success(){var _this10=this;var _state10=this.state,level_index=_state10.level_index,robot_locations=_state10.robot_locations,focused_item_key=_state10.focused_item_key,hand_state=_state10.hand_state;var level=__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */][level_index];var reset=function reset(){_this10.setState({game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FILLING_STAGE});_this10.cancel_any_available_help();};var help_callback=null;var helping_hand=null;var help_timeout=null;if(hand_state===HELPING_HAND_STATES.NONE){if(level_index<__WEBPACK_IMPORTED_MODULE_19__config__["a" /* LEVELS */].length-1){help_timeout=this.create_help_timer("tap next level");}}else if(hand_state===HELPING_HAND_STATES.AVAILABLE){help_callback=function help_callback(){return _this10.setState({hand_state:HELPING_HAND_STATES.TAP_NEXT_LEVEL,hand_substate:0});};}else{var button_top_corner=level_button_positions[level_index+1];var final_position={left:button_top_corner.left+LEVEL_BUTTON_WIDTH/2,top:button_top_corner.top+LEVEL_BUTTON_HEIGHT/2};helping_hand=this.render_hand_moving_and_clicking(final_position);}return this.render_app({help_timeout:help_timeout,help_callback:help_callback,helping_hand:helping_hand,progress_bar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ProgressBar__["a" /* default */],{level:level_index,current_input_length:level.max_sequence_length}),robots:robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Robot,{number:robot_index+1,large:robot_locations[robot_index].area===__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["c" /* STAGE */],visual_state:__WEBPACK_IMPORTED_MODULE_32__Robot__["a" /* ROBOT_VISUAL_STATES */].SINGING});}),panel_place_holders:panel_indeces.map(function(panel_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:panel_index,is_playing:true,should_transition_to_current_color:false});}),stage_place_holders:level.stage_indeces.map(function(stage_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__PlaceHolder__["a" /* default */],{key:stage_index,is_playing:true,should_transition_to_current_color:false});}),stage_controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__StageControls__["b" /* default */],{button:__WEBPACK_IMPORTED_MODULE_34__StageControls__["a" /* STAGE_CONTROL_BUTTONS */].RESET,focus_ref:this.focusable_function('play_button',FOCUS_ROWS.PLAYBACK_CONTROLS),has_focus:this.shows_keyboard_focus()&&focused_item_key==='play_button',on_select:reset})});}},{key:'get_spotlight',value:function get_spotlight(){var game_state=this.state.game_state;var class_name='App-layer App-spotlight';if(game_state!=__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].PLAYING_SEQUENCE){class_name+=' App-spotlight-off';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_layers_SPOTlight_png___default.a,alt:'',className:class_name});}},{key:'get_keyboard_hints',value:function get_keyboard_hints(){var hand_state=this.state.hand_state;var visible=hand_state===HELPING_HAND_STATES.AVAILABLE;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__KeyboardHints__["a" /* default */],{visible:visible});}},{key:'get_success_layer',value:function get_success_layer(){var game_state=this.state.game_state;var visible=false;var success=false;switch(game_state){case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].LEVEL_SUCCESS:success=true;visible=true;break;case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FAILURE:visible=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__SuccessLayer__["a" /* default */],{visible:visible,success:success});}},{key:'render_app',value:function render_app(_ref){var _this11=this;var _ref$robots=_ref.robots,robots=_ref$robots===undefined?null:_ref$robots,_ref$located_robots=_ref.located_robots,located_robots=_ref$located_robots===undefined?null:_ref$located_robots,panel_place_holders=_ref.panel_place_holders,stage_place_holders=_ref.stage_place_holders,_ref$stage_controls=_ref.stage_controls,stage_controls=_ref$stage_controls===undefined?null:_ref$stage_controls,_ref$progress_bar=_ref.progress_bar,progress_bar=_ref$progress_bar===undefined?null:_ref$progress_bar,_ref$helping_hand=_ref.helping_hand,helping_hand=_ref$helping_hand===undefined?null:_ref$helping_hand,_ref$help_timeout=_ref.help_timeout,help_timeout=_ref$help_timeout===undefined?null:_ref$help_timeout,_ref$help_callback=_ref.help_callback,help_callback=_ref$help_callback===undefined?null:_ref$help_callback,_ref$state_transition=_ref.state_transition_timeout,state_transition_timeout=_ref$state_transition===undefined?null:_ref$state_transition,_ref$show_stage_quest=_ref.show_stage_question_mark,show_stage_question_mark=_ref$show_stage_quest===undefined?false:_ref$show_stage_quest,_ref$magnets_pulsing=_ref.magnets_pulsing,magnets_pulsing=_ref$magnets_pulsing===undefined?false:_ref$magnets_pulsing;var _state11=this.state,level_index=_state11.level_index,hand_timeout_counter=_state11.hand_timeout_counter,focused_item_key=_state11.focused_item_key,muted=_state11.muted,game_state=_state11.game_state;window.createjs.Sound.muted=muted;var stage_locations=stage_locations_by_level[level_index];if(!stage_controls){// must be rendered every time (for transitions to work)
// renders off-screen by default
stage_controls=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__StageControls__["b" /* default */],null);}if(robots!==null&&located_robots===null){located_robots=robot_indeces.map(function(robot_index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Draggable__["a" /* default */],{key:robot_index,draggable:false,initial_coords:_this11.getCoordinatesOfRobotPlaceHolder(robot_index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__ZeroSizeCenterer__["a" /* default */],null,robots[robot_index]));});}if(progress_bar===null){progress_bar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__ProgressBar__["a" /* default */],{level:level_index});}var mute_change=function mute_change(){return _this11.setState({muted:!muted});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App',ref:function ref(app){_this11.app_element=app;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_layers_BACKwallBLANK_png___default.a,style:{position:'absolute',left:0,top:0},alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_layers_PANELtop_png___default.a,style:{position:'absolute',left:0,top:0},alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_layers_LOAD_CONTROLbar_png___default.a,style:{position:'absolute',left:0,bottom:0},alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:stage_images[level_index],style:{position:'absolute',left:0,top:0},alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__MagnetStrobeLayer__["a" /* default */],{level_index:level_index,pulsing:magnets_pulsing}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:active_level_buttons[level_index],style:{position:'absolute',left:0,bottom:0},alt:''}),progress_bar,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__MuteButton__["a" /* default */],{focus_ref:this.focusable_function('volume_button',FOCUS_ROWS.MUTE_CONTROLS),has_focus:this.shows_keyboard_focus()&&focused_item_key==='volume_button',on_select:mute_change,currently_muted:muted}),help_callback!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__HelpButton__["a" /* default */],{visible:true,focus_ref:this.focusable_function('help_button',FOCUS_ROWS.HELP_BUTTON),has_focus:this.shows_keyboard_focus()&&focused_item_key==='help_button',on_select:help_callback}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__HelpButton__["a" /* default */],{visible:false}),stage_controls,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'App-panel-placeholders'},panel_place_holders.map(function(place_holder,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,style:{position:'absolute',top:panel_locations[index].upper_left.top,left:panel_locations[index].upper_left.left,width:panel_place_holder_half_width*2,height:panel_place_holder_half_width*2}},place_holder);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'App-stage-placeholders'},stage_place_holders.map(function(place_holder,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,style:{position:'absolute',top:stage_locations[index].upper_left.top,left:stage_locations[index].upper_left.left,width:stage_place_holder_half_width*2,height:stage_place_holder_half_width*2}},place_holder);})),BUTTON_INDECES.map(function(button_index){var active=button_index===level_index;var listener=active?null:function(){return _this11.setState({hand_timeout_counter:hand_timeout_counter+1,level_index:button_index,robot_locations:_this11.robotLocationsUpdatedForLevel(button_index),game_state:__WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FILLING_STAGE});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__InvisibleButton__["a" /* default */],{key:button_index,focus_ref:_this11.focusable_function(level_control_key(button_index),FOCUS_ROWS.LEVEL_CONTROLS),has_focus:_this11.shows_keyboard_focus()&&focused_item_key===level_control_key(button_index),on_select:listener,width:LEVEL_BUTTON_WIDTH,height:LEVEL_BUTTON_HEIGHT,left:level_button_positions[button_index].left,top:level_button_positions[button_index].top});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-layer',style:{pointerEvents:'none'}},located_robots),this.get_spotlight(),this.get_success_layer(),this.get_keyboard_hints(),helping_hand,DISABLE_HAND?null:help_timeout,state_transition_timeout,helping_hand?// add full-screen overlay to intercept touch events and prevent default actions
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App-layer'}):null);}},{key:'render',value:function render(){var game_state=this.state.game_state;switch(game_state){case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FILLING_STAGE:return this.render_filling();case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].PLAYING_SEQUENCE:return this.render_playing();case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].REPEATING_SEQUENCE:return this.render_repeating();case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].SEQUENCE_SUCCESS:return this.render_sequence_success();case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].LEVEL_SUCCESS:return this.render_level_success();case __WEBPACK_IMPORTED_MODULE_18__AppConstants_js__["a" /* GAME_STATES */].FAILURE:return this.render_failure();default:return null;}}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(21);
var $find = __webpack_require__(25)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(44)(KEY);


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(140);
var IE8_DOM_DEFINE = __webpack_require__(141);
var toPrimitive = __webpack_require__(143);
var dP = Object.defineProperty;

exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(23) && !__webpack_require__(24)(function () {
  return Object.defineProperty(__webpack_require__(142)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(6).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var hide = __webpack_require__(22);
var has = __webpack_require__(146);
var SRC = __webpack_require__(40)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(7).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 146 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(42);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(150);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(152);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(154);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var isArray = __webpack_require__(155);
var SPECIES = __webpack_require__(43)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(42);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(6);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(21);
var $find = __webpack_require__(25)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(44)(KEY);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(159);
module.exports = __webpack_require__(7).Array.some;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(21);
var $some = __webpack_require__(25)(3);

$export($export.P + $export.F * !__webpack_require__(160)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(24);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/question-mark.2e541755.svg";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BACKwallBLANK.ac1b7253.png";

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOAD_CONTROLbar.139d3e49.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PANELtop.5ce1dd51.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3targets.092b9c3d.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4targets.e709faec.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6targets.4c1f9ae0.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SPOTlight.222436b5.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SELECTstage3.4c2e4df0.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SELECTstage4.5387f6de.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SELECTstage6.2907b225.png";

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GAME_STATES; });
// locations a robot might be
var PANEL={};var STAGE={};var GAME_STATES={FILLING_STAGE:'filling',PLAYING_SEQUENCE:'playing',REPEATING_SEQUENCE:'repeating',SEQUENCE_SUCCESS:'sequence success',// in this state, all robots cheer
// wait for user to either hit "replay" button
// or change level
LEVEL_SUCCESS:'level success',// show failure indication,
// wait for user to either hit "replay" button
// or change level
FAILURE:'failure'};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEVELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_HAND_IMMEDIATELY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_range__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_range__);
// This file is here mostly so I can simplify the game while debugging,
// but still make changes to and commit App.js
function make_level(stage_count,notes_per_sequence,note_duration){var sequence_count=notes_per_sequence.length;return{stage_count:stage_count,stage_indeces:__WEBPACK_IMPORTED_MODULE_0_range___default.a.range(stage_count),sequence_count:sequence_count,max_sequence_length:notes_per_sequence[sequence_count-1],notes_per_sequence:notes_per_sequence};}var LEVELS=[make_level(3,[1,2,3,4,5,6]),make_level(4,[1,2,3,4,5,6,7,8,9,10]),make_level(6,[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16])];var START_HAND_IMMEDIATELY=true;

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
    This is a wrapper component implementing basic drag and drop.
    It uses an absolutely position element, and updates the elements top and left CSS values.
*/var touchmove_listener_options={/*
        See here for passive vs active listeners: 
        https://developers.google.com/web/updates/2016/06/passive-event-listeners
        On mobile chrome, touchmove is passive by default, which prevents us
        from preventing pull-to-refresh
    */passive:false};var Draggable=function(_Component){_inherits(Draggable,_Component);function Draggable(props){_classCallCheck(this,Draggable);var _this=_possibleConstructorReturn(this,(Draggable.__proto__||Object.getPrototypeOf(Draggable)).call(this,props));_this.onMouseDown=function(event){if(!_this.props.draggable){return;}/*
            Calculate "initial_offset", which involves several things:
                - cursor position relative to the Draggable element
                - the Draggable element's offsetParent's position relative to view port

            We'll use this in subsequent event handlers to convert from view port coordinates
            back to appropriate left/top values for the Draggable element.
        */var position=_this.getClientPosition(event);var initial_offset={x:position.x-_this.props.initial_coords.left,y:position.y-_this.props.initial_coords.top};_this.setState({drag_location:_this.props.initial_coords,is_dragging:true,initial_offset:initial_offset});window.addEventListener('mouseup',_this.finish_dragging,{once:true});// 'touchstart' isn't always followed by 'touchend'
// for a quick touch, it will fire 'touchcancel' instead
window.addEventListener('touchend',_this.finish_dragging,{once:true});window.addEventListener('touchcancel',_this.finish_dragging,{once:true});_this.props.on_drag_start(_this.props.initial_coords,_this.element);/* 
            Prevent page over-scroll (mobile safari)
            If we want to disable over-scroll entirely, we might want to add event listener
            directly to the window and always preventDefault
        */event.preventDefault();};_this.finish_dragging=function(){// this might fire multiple times when canceling the same drag
// be sure to get updated state
_this.setState(function(previous_state){if(!previous_state.is_dragging){return{};}_this.props.on_drag_end(previous_state.drag_location,_this.element);return{is_dragging:false};});};_this.onMouseMove=function(event){if(!_this.state.is_dragging){return;}var position=_this.getClientPosition(event);var location={left:position.x-_this.state.initial_offset.x,top:position.y-_this.state.initial_offset.y};_this.setState({drag_location:location});_this.props.on_drag(location,_this.element);/*
            This isn't really needed on desktop, but on mobile touchmove triggers
            page reload. We want to prevent that.
            Alternatively, we could disable pull-to-reload globally
            (even when not dragging a robot).
        */event.preventDefault();};_this.state={drag_location:props.initial_coords,is_dragging:false,initial_offset:null};return _this;}_createClass(Draggable,[{key:'getCurrentLocation',value:function getCurrentLocation(){return this.state.is_dragging?this.state.drag_location:this.props.initial_coords;}// While dragging, you might move your mouse quickly off of this element, before we can update it's position.
// For that reason, we need to attach a move listener directly to the window.
},{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('mousemove',this.onMouseMove);window.addEventListener('touchmove',this.onMouseMove,touchmove_listener_options);}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('mousemove',this.onMouseMove);window.removeEventListener('touchmove',this.onMouseMove,touchmove_listener_options);}},{key:'getClientPosition',value:function getClientPosition(event){return event.touches?{x:event.touches[0].clientX,y:event.touches[0].clientY}:{x:event.clientX,y:event.clientY};}},{key:'render',value:function render(){var _this2=this;var _props=this.props,transition=_props.transition,on_transition_end=_props.on_transition_end,children=_props.children;var location=this.getCurrentLocation();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(div){if(div){// Prevent html drag and drop of all elements inside this div.
// Without this, if you place elements which are normally draggable (ie. images) 
// inside of this component, you'll starting dragging that element (ie. native dragging)
// instead of dragging this component
div.addEventListener('dragstart',function(e){e.preventDefault();e.stopPropagation();},true);// store reference to div
_this2.element=div;}},style:{position:'absolute',left:location.left+'px',top:location.top+'px',transition:this.state.is_dragging?null:transition},onMouseDown:this.onMouseDown,onTouchStart:this.onMouseDown,onTransitionEnd:on_transition_end},children);}}]);return Draggable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Draggable);Draggable.propTypes={/*
        All coordinates here are objects of form {left: number, top: number}
        These coordinates refer to the Draggable element's position within its offsetParent
        (ie. correspond to CSS left and top values).
    */initial_coords:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,draggable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,/*
        These callbacks will called with arguments (current_coordinates, element)
    */on_drag_start:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,on_drag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,on_drag_end:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/*
        The css value to use for the 'transition' property.
        This is only applied when draggable = false.
        You can use this to animate transitions between different values of initial_coords.
        Set to 'none' to prevent default transition.
    */transition:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,on_transition_end:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Draggable.defaultProps={transition:'all 0.25s ease-in'};

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Fader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fader_css__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Fader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Fader_css__);
function Fader(_ref){var _ref$visible=_ref.visible,visible=_ref$visible===undefined?false:_ref$visible,_ref$on_transition_en=_ref.on_transition_end,on_transition_end=_ref$on_transition_en===undefined?null:_ref$on_transition_en,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()("Fader",{'Fader-visible':visible}),onTransitionEnd:on_transition_end},children);}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find_index__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_fn_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_fn_array_find__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
	This class is for implementing keyboard (arrow key) navigation. 

	It organizes all elements into horizontal rows (which the user defines explicitly).
	Left/right move within a "row".

	Up/down move between rows. The nearest element horizontally is chosen, based on actual element position.

	It uses "keys" to logically identify elements. These keys can be anything, and will be compared for strict equality.
*/function getCenterX(element){var rect=element.getBoundingClientRect();return rect.left+rect.width/2;}function orderHorizontally(focus_children){focus_children.sort(function(c1,c2){return getCenterX(c1.element)-getCenterX(c2.element);});}var FocusManager=function(){function FocusManager(on_focus_changed){_classCallCheck(this,FocusManager);this.on_focus_changed=on_focus_changed;this.wraps_horizontally=true;this.wraps_vertically=false;this.focus_children=[];this.focused_child_key=null;window.addEventListener('keydown',this._handle_keydown.bind(this));}// call with element = null to remove focusability
_createClass(FocusManager,[{key:'register',value:function register(key,row_level,element){var focus_children=this.focus_children,focused_child_key=this.focused_child_key;var index=focus_children.findIndex(function(child){return child.key===key;});// we are de-registering this item
if(element===null){// ensure item is still in list
if(index>=0){var child=focus_children[index];// unfocus child, if necessary
if(child.key===focused_child_key){this._set_focused(null);}// remove child from array
focus_children.splice(index,1);}}// adding or changing item
else{var new_child={key:key,row_level:row_level,element:element};if(index>=0){focus_children[index]=new_child;}else{focus_children.push(new_child);}}}},{key:'move',value:function move(direction){// TODO
console.log(direction);var focus_children=this.focus_children,focused_child_key=this.focused_child_key;if(focus_children.length===0){return;}if(focused_child_key===null){// nothing is focused - start with upper-right element
var row_level=this._get_levels()[0];var candidates=this._children_in_level(row_level);this._set_focused(candidates[0].key);return;}var focused_child=focus_children.find(function(c){return c.key===focused_child_key;});if(direction==='right'){var _candidates=this._children_in_level(focused_child.row_level);var index=_candidates.findIndex(function(c){return c===focused_child;});if(index===_candidates.length-1){if(this.wraps_horizontally){this._set_focused(_candidates[0].key);}}else{this._set_focused(_candidates[index+1].key);}}else if(direction==='left'){var _candidates2=this._children_in_level(focused_child.row_level);var _index=_candidates2.findIndex(function(c){return c===focused_child;});if(_index===0){if(this.wraps_horizontally){this._set_focused(_candidates2[_candidates2.length-1].key);}}else{this._set_focused(_candidates2[_index-1].key);}}else if(direction==='up'||direction==='down'){var levels=this._get_levels();var level_index=levels.findIndex(function(rl){return rl===focused_child.row_level;});var target_level_index=null;if(direction==='up'){if(level_index===0){if(this.wraps_vertically){target_level_index=levels.length-1;}}else{target_level_index=level_index-1;}}// direction is down
else{if(level_index===levels.length-1){if(this.wraps_vertically){target_level_index=0;}}else{target_level_index=level_index+1;}}if(target_level_index===null){// we don't support wrapping
return;}var center_x=getCenterX(focused_child.element);var _candidates3=this._children_in_level(levels[target_level_index]);var closest_distance=null;var closest=null;_candidates3.forEach(function(focus_child){var distance=Math.abs(getCenterX(focus_child.element)-center_x);if(closest_distance===null||distance<closest_distance){closest_distance=distance;closest=focus_child;}});this._set_focused(closest.key);}}},{key:'_get_levels',value:function _get_levels(){// extract row_levels
var levels=this.focus_children.map(function(c){return c.row_level;});// sort ascending
levels.sort(function(a,b){return a-b;});// eliminate duplicates
return levels.filter(function(element,index,array){return index===0||element!==array[index-1];});}},{key:'_children_in_level',value:function _children_in_level(row_level){var result=this.focus_children.filter(function(c){return c.row_level===row_level;});orderHorizontally(result);return result;}},{key:'_set_focused',value:function _set_focused(key){this.focused_child_key=key;this.on_focus_changed(key);}},{key:'_handle_keydown',value:function _handle_keydown(event){switch(event.key){case'ArrowRight':case'Right':// for IE
this.move('right');break;case'ArrowLeft':case'Left':// for IE
this.move('left');break;case'ArrowUp':case'Up':// for IE
this.move('up');break;case'ArrowDown':case'Down':// for IE
this.move('down');break;default:break;}}}]);return FocusManager;}();/* harmony default export */ __webpack_exports__["a"] = (FocusManager);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppCoordinates;
/*
  within this app, a set of coordinates refers to an object of the form:
  {
    left: [# of pixels to the right of the left edge of app_element],
    top: [# of pixels below the top edge of app_element],
  }

  returns:
  {
    upper_left: [coordinates of u-l corner of element],
    lower_right: [coordinates of l-r cornder of element],
    center: [coordinates of center of element]
  }
*/function getAppCoordinates(element){/*
    Note - this implementation assumes app_element element is fixed to upper left of viewport
    We'll have to update if that changes (by taking app_element.getBoundingClientRect() into consideration).
  */var rect=element.getBoundingClientRect();return{upper_left:{left:rect.left,top:rect.top},lower_right:{left:rect.left+rect.width,top:rect.top+rect.height},center:{left:rect.left+rect.width/2,top:rect.top+rect.height/2}};}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvisibleButton__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_HELP_png__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_HELP_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_HELP_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelpButton_css__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HelpButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HelpButton_css__);
var HelpButton=function HelpButton(_ref){var visible=_ref.visible,_ref$focus_ref=_ref.focus_ref,focus_ref=_ref$focus_ref===undefined?null:_ref$focus_ref,_ref$has_focus=_ref.has_focus,has_focus=_ref$has_focus===undefined?false:_ref$has_focus,_ref$on_select=_ref.on_select,on_select=_ref$on_select===undefined?null:_ref$on_select;var button=visible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InvisibleButton__["a" /* default */],{focus_ref:focus_ref,has_focus:has_focus,on_select:on_select,width:112,height:200,left:0,top:0}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('HelpButton',{'HelpButton-hidden':!visible})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_HELP_png___default.a,alt:''}),button);};/* harmony default export */ __webpack_exports__["a"] = (HelpButton);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HELP.c75e1bb4.png";

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Timer__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_keyboard_UP_png__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_keyboard_UP_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_keyboard_UP_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_keyboard_DWN_png__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_keyboard_DWN_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_keyboard_DWN_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_keyboard_LFT_png__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_keyboard_LFT_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_keyboard_LFT_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_keyboard_RT_png__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_keyboard_RT_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_keyboard_RT_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_keyboard_SPACE_png__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_keyboard_SPACE_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_keyboard_SPACE_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__KeyboardHints_css__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__KeyboardHints_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__KeyboardHints_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var KeyboardHintListener=function(_Component){_inherits(KeyboardHintListener,_Component);function KeyboardHintListener(props){_classCallCheck(this,KeyboardHintListener);var _this=_possibleConstructorReturn(this,(KeyboardHintListener.__proto__||Object.getPrototypeOf(KeyboardHintListener)).call(this,props));_this.listener=function(){_this.props.on_interaction();};window.addEventListener('click',_this.listener,true);window.addEventListener('keydown',_this.listener,true);return _this;}_createClass(KeyboardHintListener,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('click',this.listener,true);window.removeEventListener('keydown',this.listener,true);}},{key:'render',value:function render(){return null;}}]);return KeyboardHintListener;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var KeyboardHints=function(_Component2){_inherits(KeyboardHints,_Component2);function KeyboardHints(props){_classCallCheck(this,KeyboardHints);var _this2=_possibleConstructorReturn(this,(KeyboardHints.__proto__||Object.getPrototypeOf(KeyboardHints)).call(this,props));_this2.state={dismissed:false};return _this2;}_createClass(KeyboardHints,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.visible&&!this.props.visible){this.setState({dismissed:false});}}},{key:'render',value:function render(){var _this3=this;var dismissed=this.state.dismissed;var visible=this.props.visible;var is_visible=visible&&!dismissed;var container_class="KeyboardHints App-layer";if(!is_visible){container_class+=' KeyboardHints-left';}var no_events_style={pointerEvents:'none'};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:container_class,style:no_events_style},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(KeyboardHintListener,{on_interaction:function on_interaction(){return _this3.setState({dismissed:true});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_keyboard_UP_png___default.a,className:'App-layer',style:no_events_style}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_keyboard_DWN_png___default.a,className:'App-layer',style:no_events_style}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_keyboard_LFT_png___default.a,className:'App-layer',style:no_events_style}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_keyboard_RT_png___default.a,className:'App-layer',style:no_events_style}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_keyboard_SPACE_png___default.a,className:'App-layer',style:no_events_style}));return null;}}]);return KeyboardHints;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (KeyboardHints);KeyboardHints.propTypes={visible:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/UP.1b463abe.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/DWN.e19c317d.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LFT.143211e3.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/RT.11af1a14.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SPACE.2b0c6b51.png";

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Timer_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MagnetStrobeLayer_css__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MagnetStrobeLayer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__MagnetStrobeLayer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_panel_strobe_P01_png__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_panel_strobe_P01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_panel_strobe_P01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_panel_strobe_P02_png__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_panel_strobe_P02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_panel_strobe_P02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_panel_strobe_P03_png__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_panel_strobe_P03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_panel_strobe_P03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_panel_strobe_P04_png__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_panel_strobe_P04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_panel_strobe_P04_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_STAGE3strobe_S3_01_png__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_STAGE3strobe_S3_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_STAGE3strobe_S3_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_STAGE3strobe_S3_02_png__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_STAGE3strobe_S3_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_STAGE3strobe_S3_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_STAGE3strobe_S3_03_png__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_STAGE3strobe_S3_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_STAGE3strobe_S3_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_STAGE3strobe_S3_04_png__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_STAGE3strobe_S3_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_STAGE3strobe_S3_04_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_STAGE4strobe_S4_01_png__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_STAGE4strobe_S4_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_STAGE4strobe_S4_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_STAGE4strobe_S4_02_png__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_STAGE4strobe_S4_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_STAGE4strobe_S4_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_STAGE4strobe_S4_03_png__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_STAGE4strobe_S4_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_STAGE4strobe_S4_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_STAGE4strobe_S4_04_png__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_STAGE4strobe_S4_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_STAGE4strobe_S4_04_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_STAGE6strobe_S6_01_png__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_STAGE6strobe_S6_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_STAGE6strobe_S6_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_STAGE6strobe_S6_02_png__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_STAGE6strobe_S6_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_STAGE6strobe_S6_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_STAGE6strobe_S6_03_png__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_STAGE6strobe_S6_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_STAGE6strobe_S6_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_STAGE6strobe_S6_04_png__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_STAGE6strobe_S6_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_STAGE6strobe_S6_04_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var panel_strobes=[null,__WEBPACK_IMPORTED_MODULE_4__assets_panel_strobe_P01_png___default.a,__WEBPACK_IMPORTED_MODULE_5__assets_panel_strobe_P02_png___default.a,__WEBPACK_IMPORTED_MODULE_6__assets_panel_strobe_P03_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_panel_strobe_P04_png___default.a];var stage_strobes_by_level=[[null,__WEBPACK_IMPORTED_MODULE_8__assets_STAGE3strobe_S3_01_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_STAGE3strobe_S3_02_png___default.a,__WEBPACK_IMPORTED_MODULE_10__assets_STAGE3strobe_S3_03_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_STAGE3strobe_S3_04_png___default.a],[null,__WEBPACK_IMPORTED_MODULE_12__assets_STAGE4strobe_S4_01_png___default.a,__WEBPACK_IMPORTED_MODULE_13__assets_STAGE4strobe_S4_02_png___default.a,__WEBPACK_IMPORTED_MODULE_14__assets_STAGE4strobe_S4_03_png___default.a,__WEBPACK_IMPORTED_MODULE_15__assets_STAGE4strobe_S4_04_png___default.a],[null,__WEBPACK_IMPORTED_MODULE_16__assets_STAGE6strobe_S6_01_png___default.a,__WEBPACK_IMPORTED_MODULE_17__assets_STAGE6strobe_S6_02_png___default.a,__WEBPACK_IMPORTED_MODULE_18__assets_STAGE6strobe_S6_03_png___default.a,__WEBPACK_IMPORTED_MODULE_19__assets_STAGE6strobe_S6_04_png___default.a]];var MagnetStrobeLayer=function(_Component){_inherits(MagnetStrobeLayer,_Component);function MagnetStrobeLayer(props){_classCallCheck(this,MagnetStrobeLayer);var _this=_possibleConstructorReturn(this,(MagnetStrobeLayer.__proto__||Object.getPrototypeOf(MagnetStrobeLayer)).call(this,props));_this.state={pulse_index:0};return _this;}_createClass(MagnetStrobeLayer,[{key:'render',value:function render(){var _this2=this;var _props=this.props,pulsing=_props.pulsing,level_index=_props.level_index;var pulse_index=this.state.pulse_index;if(!pulsing){return null;}var timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Timer_js__["a" /* default */],{delay:340,on_timeout:function on_timeout(){_this2.setState(function(old_state){return{pulse_index:(old_state.pulse_index+1)%panel_strobes.length};});},reset_prevention_key:pulse_index});if(!pulse_index){return timer;}var stage_strobes=stage_strobes_by_level[level_index];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MagnetStrobeLayer'},timer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:panel_strobes[pulse_index],className:'MagnetStrobeLayer',alt:'',style:{left:55,top:45}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:stage_strobes[pulse_index],className:'MagnetStrobeLayer',alt:''}));}}]);return MagnetStrobeLayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MagnetStrobeLayer.propTypes={level_index:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,pulsing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (MagnetStrobeLayer);

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/P01.55f3ee40.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/P02.3b3a1141.png";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/P03.47795af8.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/P04.a5d2563c.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S3_01.487d93e1.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S3_02.57b596e9.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S3_03.b70ca017.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S3_04.45462136.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S4_01.5d7b5c67.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S4_02.4d96f539.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S4_03.2eccb665.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S4_04.b5caa1db.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S6_01.57443081.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S6_02.e8c961a0.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S6_03.25db36c0.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/S6_04.cfdc6a63.png";

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvisibleButton__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_SOUNDon_png__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_SOUNDon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_SOUNDon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_SOUNDoff_png__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_SOUNDoff_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_SOUNDoff_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MuteButton_css__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MuteButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MuteButton_css__);
var MuteButton=function MuteButton(_ref){var currently_muted=_ref.currently_muted,_ref$focus_ref=_ref.focus_ref,focus_ref=_ref$focus_ref===undefined?null:_ref$focus_ref,_ref$has_focus=_ref.has_focus,has_focus=_ref$has_focus===undefined?false:_ref$has_focus,_ref$on_select=_ref.on_select,on_select=_ref$on_select===undefined?null:_ref$on_select;var button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InvisibleButton__["a" /* default */],{focus_ref:focus_ref,has_focus:has_focus,on_select:on_select,width:185,height:150,right:0,top:0});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MuteButton'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:currently_muted?__WEBPACK_IMPORTED_MODULE_4__assets_SOUNDoff_png___default.a:__WEBPACK_IMPORTED_MODULE_3__assets_SOUNDon_png___default.a,alt:''}),button);};/* harmony default export */ __webpack_exports__["a"] = (MuteButton);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/SOUNDoff.ad09f68e.png";

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__KeyboardSelectionListener__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaceHolder_css__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaceHolder_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PlaceHolder_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
    A "PlaceHolder" is a slot where a robot can go.
    These used to be visibile elements, but we've replaced that with background images.
    Now these are mostly just targets for click/keyboard events.
*/var PlaceHolder=function(_Component){_inherits(PlaceHolder,_Component);function PlaceHolder(){_classCallCheck(this,PlaceHolder);return _possibleConstructorReturn(this,(PlaceHolder.__proto__||Object.getPrototypeOf(PlaceHolder)).apply(this,arguments));}_createClass(PlaceHolder,[{key:'render',value:function render(){var _props=this.props,on_select=_props.on_select,has_focus=_props.has_focus,focus_child_ref_func=_props.focus_child_ref_func;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PlaceHolder PlaceHolder-click-target',ref:focus_child_ref_func,onClick:on_select,style:{outline:has_focus?'6px solid orange':'none'}},has_focus?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__KeyboardSelectionListener__["a" /* default */],{on_select:on_select}):null);}}]);return PlaceHolder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PlaceHolder);PlaceHolder.propTypes={on_select:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,has_focus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,// One of the elements rendered by PlaceHolder is "focusable"
// this is a function to pass to the ref of that element
focus_child_ref_func:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,// these effectively map to specific colors
// we should really turn this into one 'color' prop
is_hovered:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,is_error:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,is_playing:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,is_correct:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,// default true
// make sure to set false if you want an immediate color change
should_transition_to_current_color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};PlaceHolder.defaultProps={has_focus:false,should_transition_to_current_color:true};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProgressBar_css__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProgressBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ProgressBar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_progress_bar_green_PB_G_01_png__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_progress_bar_green_PB_G_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_progress_bar_green_PB_G_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_progress_bar_green_PB_G_02_png__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_progress_bar_green_PB_G_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_progress_bar_green_PB_G_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_progress_bar_green_PB_G_03_png__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_progress_bar_green_PB_G_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_progress_bar_green_PB_G_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_progress_bar_green_PB_G_04_png__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_progress_bar_green_PB_G_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_progress_bar_green_PB_G_04_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_progress_bar_green_PB_G_05_png__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_progress_bar_green_PB_G_05_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_progress_bar_green_PB_G_05_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_progress_bar_green_PB_G_06_png__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_progress_bar_green_PB_G_06_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_progress_bar_green_PB_G_06_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_progress_bar_green_PB_G_07_png__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_progress_bar_green_PB_G_07_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_progress_bar_green_PB_G_07_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_progress_bar_green_PB_G_08_png__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_progress_bar_green_PB_G_08_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_progress_bar_green_PB_G_08_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_progress_bar_green_PB_G_09_png__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_progress_bar_green_PB_G_09_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_progress_bar_green_PB_G_09_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_progress_bar_green_PB_G_10_png__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_progress_bar_green_PB_G_10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_progress_bar_green_PB_G_10_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_progress_bar_green_PB_G_11_png__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_progress_bar_green_PB_G_11_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_progress_bar_green_PB_G_11_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_progress_bar_green_PB_G_12_png__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_progress_bar_green_PB_G_12_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_progress_bar_green_PB_G_12_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_progress_bar_green_PB_G_13_png__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_progress_bar_green_PB_G_13_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_progress_bar_green_PB_G_13_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_progress_bar_green_PB_G_14_png__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_progress_bar_green_PB_G_14_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_progress_bar_green_PB_G_14_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_progress_bar_green_PB_G_15_png__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_progress_bar_green_PB_G_15_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_progress_bar_green_PB_G_15_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_progress_bar_green_PB_G_16_png__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_progress_bar_green_PB_G_16_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_progress_bar_green_PB_G_16_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_progress_bar_yellow_PB_Y_01_png__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_progress_bar_yellow_PB_Y_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_progress_bar_yellow_PB_Y_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_progress_bar_yellow_PB_Y_02_png__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_progress_bar_yellow_PB_Y_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_progress_bar_yellow_PB_Y_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_progress_bar_yellow_PB_Y_03_png__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_progress_bar_yellow_PB_Y_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_progress_bar_yellow_PB_Y_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_progress_bar_yellow_PB_Y_04_png__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_progress_bar_yellow_PB_Y_04_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_progress_bar_yellow_PB_Y_04_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_progress_bar_yellow_PB_Y_05_png__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_progress_bar_yellow_PB_Y_05_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_progress_bar_yellow_PB_Y_05_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_progress_bar_yellow_PB_Y_06_png__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_progress_bar_yellow_PB_Y_06_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_progress_bar_yellow_PB_Y_06_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_progress_bar_yellow_PB_Y_07_png__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_progress_bar_yellow_PB_Y_07_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_progress_bar_yellow_PB_Y_07_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_progress_bar_yellow_PB_Y_08_png__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_progress_bar_yellow_PB_Y_08_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_progress_bar_yellow_PB_Y_08_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_progress_bar_yellow_PB_Y_09_png__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_progress_bar_yellow_PB_Y_09_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_progress_bar_yellow_PB_Y_09_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_progress_bar_yellow_PB_Y_10_png__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_progress_bar_yellow_PB_Y_10_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_progress_bar_yellow_PB_Y_10_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_progress_bar_yellow_PB_Y_11_png__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_progress_bar_yellow_PB_Y_11_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_progress_bar_yellow_PB_Y_11_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_progress_bar_yellow_PB_Y_12_png__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_progress_bar_yellow_PB_Y_12_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_progress_bar_yellow_PB_Y_12_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_progress_bar_yellow_PB_Y_13_png__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_progress_bar_yellow_PB_Y_13_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_progress_bar_yellow_PB_Y_13_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_progress_bar_yellow_PB_Y_14_png__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_progress_bar_yellow_PB_Y_14_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_progress_bar_yellow_PB_Y_14_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_progress_bar_yellow_PB_Y_15_png__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__assets_progress_bar_yellow_PB_Y_15_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__assets_progress_bar_yellow_PB_Y_15_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_progress_bar_yellow_PB_Y_16_png__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__assets_progress_bar_yellow_PB_Y_16_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__assets_progress_bar_yellow_PB_Y_16_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_progress_bar_LEVEL3_PROGRESS_png__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__assets_progress_bar_LEVEL3_PROGRESS_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__assets_progress_bar_LEVEL3_PROGRESS_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_progress_bar_LEVEL4_PROGRESS_png__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__assets_progress_bar_LEVEL4_PROGRESS_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__assets_progress_bar_LEVEL4_PROGRESS_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
	The purpose of this component is to display the various lit-up states
	of the lights in the progress bar. It does not actually display the
	main progress bar image. That is a static background image.
*/var green_lights=[__WEBPACK_IMPORTED_MODULE_3__assets_progress_bar_green_PB_G_01_png___default.a,__WEBPACK_IMPORTED_MODULE_4__assets_progress_bar_green_PB_G_02_png___default.a,__WEBPACK_IMPORTED_MODULE_5__assets_progress_bar_green_PB_G_03_png___default.a,__WEBPACK_IMPORTED_MODULE_6__assets_progress_bar_green_PB_G_04_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_progress_bar_green_PB_G_05_png___default.a,__WEBPACK_IMPORTED_MODULE_8__assets_progress_bar_green_PB_G_06_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_progress_bar_green_PB_G_07_png___default.a,__WEBPACK_IMPORTED_MODULE_10__assets_progress_bar_green_PB_G_08_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_progress_bar_green_PB_G_09_png___default.a,__WEBPACK_IMPORTED_MODULE_12__assets_progress_bar_green_PB_G_10_png___default.a,__WEBPACK_IMPORTED_MODULE_13__assets_progress_bar_green_PB_G_11_png___default.a,__WEBPACK_IMPORTED_MODULE_14__assets_progress_bar_green_PB_G_12_png___default.a,__WEBPACK_IMPORTED_MODULE_15__assets_progress_bar_green_PB_G_13_png___default.a,__WEBPACK_IMPORTED_MODULE_16__assets_progress_bar_green_PB_G_14_png___default.a,__WEBPACK_IMPORTED_MODULE_17__assets_progress_bar_green_PB_G_15_png___default.a,__WEBPACK_IMPORTED_MODULE_18__assets_progress_bar_green_PB_G_16_png___default.a];var yellow_lights=[__WEBPACK_IMPORTED_MODULE_19__assets_progress_bar_yellow_PB_Y_01_png___default.a,__WEBPACK_IMPORTED_MODULE_20__assets_progress_bar_yellow_PB_Y_02_png___default.a,__WEBPACK_IMPORTED_MODULE_21__assets_progress_bar_yellow_PB_Y_03_png___default.a,__WEBPACK_IMPORTED_MODULE_22__assets_progress_bar_yellow_PB_Y_04_png___default.a,__WEBPACK_IMPORTED_MODULE_23__assets_progress_bar_yellow_PB_Y_05_png___default.a,__WEBPACK_IMPORTED_MODULE_24__assets_progress_bar_yellow_PB_Y_06_png___default.a,__WEBPACK_IMPORTED_MODULE_25__assets_progress_bar_yellow_PB_Y_07_png___default.a,__WEBPACK_IMPORTED_MODULE_26__assets_progress_bar_yellow_PB_Y_08_png___default.a,__WEBPACK_IMPORTED_MODULE_27__assets_progress_bar_yellow_PB_Y_09_png___default.a,__WEBPACK_IMPORTED_MODULE_28__assets_progress_bar_yellow_PB_Y_10_png___default.a,__WEBPACK_IMPORTED_MODULE_29__assets_progress_bar_yellow_PB_Y_11_png___default.a,__WEBPACK_IMPORTED_MODULE_30__assets_progress_bar_yellow_PB_Y_12_png___default.a,__WEBPACK_IMPORTED_MODULE_31__assets_progress_bar_yellow_PB_Y_13_png___default.a,__WEBPACK_IMPORTED_MODULE_32__assets_progress_bar_yellow_PB_Y_14_png___default.a,__WEBPACK_IMPORTED_MODULE_33__assets_progress_bar_yellow_PB_Y_15_png___default.a,__WEBPACK_IMPORTED_MODULE_34__assets_progress_bar_yellow_PB_Y_16_png___default.a];var ProgressBar=function(_Component){_inherits(ProgressBar,_Component);function ProgressBar(){_classCallCheck(this,ProgressBar);return _possibleConstructorReturn(this,(ProgressBar.__proto__||Object.getPrototypeOf(ProgressBar)).apply(this,arguments));}_createClass(ProgressBar,[{key:'render',value:function render(){var _props=this.props,level=_props.level,current_playback_length=_props.current_playback_length,current_input_length=_props.current_input_length;var layers=[];var i=0;while(i<current_playback_length){layers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:yellow_lights[i],alt:'',className:'ProgressBar-image',key:'orange'+i}));i++;}i=0;while(i<current_input_length){layers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:green_lights[i],alt:'',className:'ProgressBar-image',key:'green'+i}));i++;}var cover_img=null;if(level===0){cover_img=__WEBPACK_IMPORTED_MODULE_35__assets_progress_bar_LEVEL3_PROGRESS_png___default.a;}else if(level===1){cover_img=__WEBPACK_IMPORTED_MODULE_36__assets_progress_bar_LEVEL4_PROGRESS_png___default.a;}if(cover_img){layers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:cover_img,alt:'',className:'ProgressBar-image',key:'cover'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,layers);}}]);return ProgressBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ProgressBar);ProgressBar.propTypes={level:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,current_playback_length:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,current_input_length:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};ProgressBar.defaultProps={level:0,current_playback_length:0,current_input_length:0};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_02.e633bd12.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_03.522b2f6b.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_04.1aca8641.png";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_05.cadd8bec.png";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_06.c267e1e7.png";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_07.4ba77e32.png";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_08.eac198cb.png";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_09.eb2dde09.png";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_10.3f8c554a.png";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_11.627e9b23.png";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_12.cd856911.png";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_13.b662fc41.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_14.ab372479.png";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_15.85a9a5f4.png";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_G_16.850f0af4.png";

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_02.7b3b3ef0.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_03.6b9ec928.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_04.67d9905c.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_05.3d0d664f.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_06.612a859f.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_07.b58d8383.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_08.dc652241.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_09.2ffb6114.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_10.b4ce941a.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_11.eedf6a98.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_12.ad1c0172.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_13.d1927d20.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_14.f3445604.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_15.789d3ad8.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PB_Y_16.001e4dfc.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LEVEL3_PROGRESS.84ae3825.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LEVEL4_PROGRESS.c4f12a7c.png";

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/01A.b376a03e.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/02A.e08b4f16.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/03A.6fcfbd9d.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/04A.fa078bf2.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/05A.6a241f1c.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/06A.13d330e4.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/07A.543b3861.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/08A.8a165366.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/09A.e9ce9e85.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/01B.2d442a46.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/02B.e01e002a.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/03B.104156b2.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/04B.38dd8e61.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/05B.c598c7eb.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/06B.a2cfabaf.png";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/07B.c46e5a07.png";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/08B.8a4849f6.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/09B.e818851d.png";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/01B2.c76c6b91.png";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/02B2.f85ee11f.png";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/03B2.d9a5f115.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/04B2.5345a13b.png";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/05B2.53c96f1f.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/06B2.115bbc29.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/07B2.65ae6bf5.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/08B2.6d89a01a.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/09B2.f6c2490f.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/01C.34ede2bc.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/02C.6bf1a0df.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/03C.3533c17e.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/04C.a5830762.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/05C.01ec3799.png";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/06C.3da22f9f.png";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/07C.b3b6eed9.png";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/08C.508077dd.png";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/09C.c3361de1.png";

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RobotHand_css__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RobotHand_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RobotHand_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Timer__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RobotHand=function(_Component){_inherits(RobotHand,_Component);function RobotHand(props){_classCallCheck(this,RobotHand);var _this=_possibleConstructorReturn(this,(RobotHand.__proto__||Object.getPrototypeOf(RobotHand)).call(this,props));_this.state={src:props.is_clicking?__WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png___default.a:__WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png___default.a};return _this;}_createClass(RobotHand,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(new_props){if(new_props.is_clicking===this.props.is_clicking){return;}var new_src=null;if(new_props.is_clicking){// hand is lowering
switch(this.state.src){case __WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png___default.a:new_src=__WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default.a;break;case __WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default.a:new_src=__WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png___default.a;break;default:break;}}else{// hand is raising
switch(this.state.src){case __WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png___default.a:new_src=__WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default.a;break;case __WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default.a:new_src=__WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png___default.a;break;default:break;}}if(new_src){this.setState({src:new_src});}}},{key:'render',value:function render(){var _this2=this;var is_clicking=this.props.is_clicking;var src=this.state.src;var timer=null;if(is_clicking&&src===__WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default.a){timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Timer__["a" /* default */],{delay:100,on_timeout:function on_timeout(){return _this2.setState({src:__WEBPACK_IMPORTED_MODULE_5__assets_arm_ARM_down_03_png___default.a});},reset_prevention_key:'down'});}else if(!is_clicking&&src===__WEBPACK_IMPORTED_MODULE_4__assets_arm_ARM_mid_02_png___default.a){timer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Timer__["a" /* default */],{delay:100,on_timeout:function on_timeout(){return _this2.setState({src:__WEBPACK_IMPORTED_MODULE_3__assets_arm_ARM_up_01_png___default.a});},reset_prevention_key:'up'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,timer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:src,className:'RobotHand',alt:'Helping hand'}));}}]);return RobotHand;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RobotHand);RobotHand.propTypes={is_clicking:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ARM_up_01.6cf3d449.png";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ARM_mid_02.36049121.png";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ARM_down_03.6fe42236.png";

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STAGE_CONTROL_BUTTONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Focusable__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_PLAY_png__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_PLAY_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_PLAY_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_REPLAY_png__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_REPLAY_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_REPLAY_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StageControls_css__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StageControls_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StageControls_css__);
var STAGE_CONTROL_BUTTONS={PLAY:'play',RESET:'reset'};var StageControls=function StageControls(_ref){var _ref$button=_ref.button,button=_ref$button===undefined?STAGE_CONTROL_BUTTONS.NONE:_ref$button,_ref$focus_ref=_ref.focus_ref,focus_ref=_ref$focus_ref===undefined?null:_ref$focus_ref,_ref$has_focus=_ref.has_focus,has_focus=_ref$has_focus===undefined?false:_ref$has_focus,_ref$on_select=_ref.on_select,on_select=_ref$on_select===undefined?null:_ref$on_select;var button_div=button?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'StageControls-button-positioner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Focusable__["a" /* default */],{has_focus:has_focus,focus_ref:focus_ref,on_select:on_select},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'StageControls-button',onClick:on_select}))):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'StageControls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_PLAY_png___default.a,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('StageControls-image',{'StageControls-image-hidden':button!==STAGE_CONTROL_BUTTONS.PLAY}),alt:''}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_REPLAY_png___default.a,className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('StageControls-image',{'StageControls-image-hidden':button!==STAGE_CONTROL_BUTTONS.RESET}),alt:''}),button_div);};/* harmony default export */ __webpack_exports__["b"] = (StageControls);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/PLAY.df038900.png";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/REPLAY.bfaa7dbd.png";

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Shakeable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shaker_css__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shaker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Shaker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// must match value from Shaker.css
var animation_duration=0.8;var Shaker=function(_Component){_inherits(Shaker,_Component);function Shaker(props){_classCallCheck(this,Shaker);var _this=_possibleConstructorReturn(this,(Shaker.__proto__||Object.getPrototypeOf(Shaker)).call(this,props));_this.delay=Math.random()*-1*animation_duration+'s';return _this;}_createClass(Shaker,[{key:'render',value:function render(){var _props=this.props,shaking=_props.shaking,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:shaking?'Shaker':'',style:{animationDelay:this.delay}},children);}}]);return Shaker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Shaker);Shaker.propTypes={shaking:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Shaker.defaultProps={shaking:false};// function to wrap another component and add "shaking" prop
function Shakeable(Component){function render(_ref){var shaking=_ref.shaking,rest=_objectWithoutProperties(_ref,['shaking']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Shaker,{shaking:shaking},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,rest));}return render;}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Sound=function(_Component){_inherits(Sound,_Component);function Sound(){_classCallCheck(this,Sound);return _possibleConstructorReturn(this,(Sound.__proto__||Object.getPrototypeOf(Sound)).apply(this,arguments));}_createClass(Sound,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,sound=_props.sound,options=_props.options,on_complete=_props.on_complete;this._sound=window.createjs.Sound.play(sound,options);if(on_complete){this._sound.on('complete',on_complete);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._sound&&this._sound.stop();}},{key:'render',value:function render(){return null;}}]);return Sound;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Sound.propTypes={sound:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,on_complete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};Sound.defaultProps={options:{}};/* unused harmony default export */ var _unused_webpack_default_export = (Sound);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SoundManager_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SuccessLayer_css__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SuccessLayer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SuccessLayer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_success_GearRing_GoodJob_V1_Green_png__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_success_GearRing_GoodJob_V1_Green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_success_GearRing_GoodJob_V1_Green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_success_GearRing_GoodJob_V2_Green_png__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_success_GearRing_GoodJob_V2_Green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_success_GearRing_GoodJob_V2_Green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_success_GearRing_GoodJob_V3_Green_png__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_success_GearRing_GoodJob_V3_Green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_success_GearRing_GoodJob_V3_Green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_success_GearRing_GoodJob_V4_Green_png__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_success_GearRing_GoodJob_V4_Green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_success_GearRing_GoodJob_V4_Green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_success_GearRing_GoodJob_V5_Green_png__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_success_GearRing_GoodJob_V5_Green_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_success_GearRing_GoodJob_V5_Green_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_success_GearRing_TryAgain_V1_1_png__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_success_GearRing_TryAgain_V1_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_success_GearRing_TryAgain_V1_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_success_GearRing_TryAgain_V2_1_png__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_success_GearRing_TryAgain_V2_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_success_GearRing_TryAgain_V2_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_success_GearRing_TryAgain_V3_1_png__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_success_GearRing_TryAgain_V3_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_success_GearRing_TryAgain_V3_1_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var success_images=[__WEBPACK_IMPORTED_MODULE_5__assets_success_GearRing_GoodJob_V1_Green_png___default.a,__WEBPACK_IMPORTED_MODULE_6__assets_success_GearRing_GoodJob_V2_Green_png___default.a,__WEBPACK_IMPORTED_MODULE_7__assets_success_GearRing_GoodJob_V3_Green_png___default.a,__WEBPACK_IMPORTED_MODULE_8__assets_success_GearRing_GoodJob_V4_Green_png___default.a,__WEBPACK_IMPORTED_MODULE_9__assets_success_GearRing_GoodJob_V5_Green_png___default.a];var fail_images=[__WEBPACK_IMPORTED_MODULE_10__assets_success_GearRing_TryAgain_V1_1_png___default.a,__WEBPACK_IMPORTED_MODULE_11__assets_success_GearRing_TryAgain_V2_1_png___default.a,__WEBPACK_IMPORTED_MODULE_12__assets_success_GearRing_TryAgain_V3_1_png___default.a];function get_random_image(success){var images=success?success_images:fail_images;return Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* getRandomElement */])(images);}var success_sounds=['success_1','success_2','success_3','success_4','success_5','success_6','success_7','success_8'];var fail_sounds=['fail_1','fail_2','fail_3','fail_4','fail_5','fail_6'];function play_random_sound(success){var sounds=success?success_sounds:fail_sounds;Object(__WEBPACK_IMPORTED_MODULE_3__SoundManager_js__["d" /* play */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* getRandomElement */])(sounds));}var SuccessLayer=function(_Component){_inherits(SuccessLayer,_Component);function SuccessLayer(props){_classCallCheck(this,SuccessLayer);var _this=_possibleConstructorReturn(this,(SuccessLayer.__proto__||Object.getPrototypeOf(SuccessLayer)).call(this,props));_this.state={src:get_random_image(props.success)};return _this;}_createClass(SuccessLayer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(next_props){// Choose a random image each time this layer is made visible,
// Play a random sound each time this layer is made visible
if(next_props.visible&&!this.props.visible){this.setState({src:get_random_image(next_props.success)});play_random_sound(next_props.success);}}},{key:'render',value:function render(){var src=this.state.src;var visible=this.props.visible;var className='AppLayer SuccessLayer';if(!visible)className+=' SuccessLayer-hidden';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:className,src:src,alt:''});}}]);return SuccessLayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SuccessLayer);SuccessLayer.propTypes={success:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,visible:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-GoodJob-V1-Green.60becd26.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-GoodJob-V2-Green.12982572.png";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-GoodJob-V3-Green.1fbb684d.png";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-GoodJob-V4-Green.aeaa9e49.png";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-GoodJob-V5-Green.cabf38e8.png";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-TryAgain-V1-1.a6251141.png";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-TryAgain-V2-1.b1dbb282.png";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GearRing-TryAgain-V3-1.99da3278.png";

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ZeroSizeCenterer_css__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ZeroSizeCenterer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ZeroSizeCenterer_css__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ZeroSizeCenterer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,children));});

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_02.4b9b57c4.png";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_03.3141d876.png";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_04.6edab24f.png";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_05.4080789a.png";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_06.e8544e7d.png";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_07.0697a445.png";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_08.5cd93728.png";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_09.1fcc390f.png";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_10.ce05d7c5.png";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_11.c4f170cd.png";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADER_12.8cab031a.png";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADERpage_BG.fafc97d9.png";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADERpage_Doorleft.74e52eb6.png";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOADERpage_Doorright.5d40fd4e.png";

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WindowFitter=function(_Component){_inherits(WindowFitter,_Component);function WindowFitter(props){_classCallCheck(this,WindowFitter);var _this=_possibleConstructorReturn(this,(WindowFitter.__proto__||Object.getPrototypeOf(WindowFitter)).call(this,props));_this.state={scale:1};return _this;}_createClass(WindowFitter,[{key:'fitToWindow',value:function fitToWindow(){var width_scale=window.innerWidth/this.props.width;var height_scale=window.innerHeight/this.props.height;var scale=Math.min(width_scale,height_scale);// don't upscale on large screens
scale=Math.min(scale,1);this.setState({scale:scale});}},{key:'componentDidMount',value:function componentDidMount(){this.fitToWindow();window.addEventListener('resize',this.fitToWindow.bind(this));}// TODO - when receiving new width or height prop, call fitToWindow()
// TODO - document width/height prop types
},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(element){_this2.wrapper=element;},style:{width:this.props.width*this.state.scale+'px',height:this.props.height*this.state.scale+'px',// only required when scaling up
overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(element){_this2.scaled_element=element;},style:{transformOrigin:'0 0',transform:'scale('+this.state.scale+')'}},this.props.children));}}]);return WindowFitter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WindowFitter);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL(".",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="."+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.1cc9a61f.js